const Shared = {
    selectors: {
        "thumbnails": { selector: ".thumbnail", type: "all", scope: "document" },
        "gripSelects": { selector: ".grip_type_pdp", type: "all", scope: "document" },
        "gripGuideBtn": { selector: "#grip-guide-btn", type: "single", scope: "document" },
        "gripGuide": { selector: "#grip-guide", type: "single", scope: "document" },
        "allSwatches": { selector: ".swatch-btn", type: "all", scope: "document" },
        "pricesMain": { selector: ".product-page-template .prices", type: "single", scope: "document" },
        "backInStockInput": { selector: ".back-in-stock-notify", type: "single", scope: "document" },
        "outOfStockBtn": { selector: ".out-of-stock-main", type: "single", scope: "document" },
        "stockAlert": { selector: ".stock-alert", type: "single", scope: "document" },
        "inventoryBullet": { selector: ".bullet-point", type: "single", scope: "document" },
        "loadingSpinner": { selector: ".icon-loading-js", type: "single", scope: "document" },
        "modalBg": { selector: ".modal-background", type: "single", scope: "document" },
        "modelInfo": { selector: ".model-info", type: "all", scope: "document" },
        "notifyButtons": { selector: ".notify-me-submit", type: "all", scope: "document" },
        "notifyContainer": { selector: ".notify-me-container", type: "single", scope: "document" },
        "notifyButton": { selector: ".notify-me-submit", type: "single", scope: "document" },
        "shippingDelay": { selector: ".shipping-delay", type: "single", scope: "document" },
        "shippingDelayInput": { selector: ".shipping-delay-input", type: "single", scope: "document" },
        "loopErrorText": { selector: ".loop-exclusion-error-container", type: "single", scope: "document" },
        "verticalGallery": { selector: ".vertical-gallery-layout", type: "single", scope: "document" },
        "verticalThumbs": { selector: ".vertical-thumb-img", type: "all", scope: "document" },
        "verticalGalleries": { selector: ".vertical-gallery-layout", type: "all", scope: "document" },
        "stickyBar": { selector: ".sticky-atc-bar", type: "single", scope: "document" },
        "stickyShapeBtns": { selector: ".sticky-atc-shape-btn", type: "all", scope: "document" },
        "stickyColorBtns": { selector: ".sticky-atc-color-btn", type: "all", scope: "document" },
        "stickySubmitBtn": { selector: ".sticky-atc-submit", type: "single", scope: "document" },
        "stickyShapeLabelText": { selector: ".sticky-atc-selected-shape-text", type: "single", scope: "document" },
        "stickyColorLabelText": { selector: ".sticky-atc-selected-color-text", type: "single", scope: "document" },
        "stickyCloseBtn": { selector: ".sticky-atc-close-btn", type: "single", scope: "document" },
        "stickyFab": { selector: ".sticky-atc-fab", type: "single", scope: "document" },
        "atcContainer": { selector: ".atc-container", type: "single", scope: "document" },
        "membersOnlyContainer": { selector: ".members-only-container", type: "single", scope: "document" },
        "productDetailsContainer": { selector: ".product-details-container", type: "single", scope: "document" },
        "vipAccessOverlay": { selector: ".vip-access-overlay[data-vip-overlay-pdp='true']", type: "single", scope: "document" },
        "vipAccessCloseBtn": { selector: "[data-vip-overlay-close]", type: "single", scope: "document" }
    },
  
    init: async function(handle, variantId, okendoId, productId, productType, retired) { 
        this.productType = productType;
        Utility.fetchEls(this.selectors, this);
        this.initEventListeners();

        // Check exclusions on page load
        if (variantId) {
            this.checkLoopExclusions(variantId);
        }
    },

    // Swap a button's visible label but keep its screen-reader span (.patrol-sr-only) inside it.
    setButtonLabel: function(btn, label) {
        const srText = btn.querySelector('.patrol-sr-only');
        btn.textContent = label;
        if (srText) btn.appendChild(srText);
    },

    initEventListeners: function() {
        const { thumbnails } = this;

        // Initialize the safely-scoped vertical gallery logic
        this.initVerticalGallery();

        if (!this.modelInfo.length || window.innerWidth < 1200) {
          this.initImageGalleryEventListeners();
          if (thumbnails.length) {
              thumbnails.forEach((thumbnail) => {
                thumbnail.addEventListener('click', (event) => {
                    this.updateSelectedImage(event.target, false);
                });
              });
            }
        }
        
        // Initialize sticky bar event listeners if sticky bar exists on the page
        this.initStickyBar();

        this.initVipAccessOverlay();

        // Initialize asynchronous data listeners.
        this.initMaestraEventListeners();
    },
    
    initQuantityEventListeners: function(modal = false) {
        let minusBtns;
        let plusBtns;
        let productDetails;
        if (modal) {
            minusBtns = Modal.minusBtns;
            plusBtns = Modal.plusBtns;
            productDetails = Modal.productDetails;
        } else {
            minusBtns = ProductPage.minusBtns;
            plusBtns = ProductPage.plusBtns;
            productDetails = ProductPage.productDetails;
        }
        if (minusBtns && minusBtns.length) {
            minusBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    this.handleQuantityChange(btn, 'decrease', modal);
                });
            });
        }
        if (plusBtns && plusBtns.length) {
            plusBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    this.handleQuantityChange(btn, 'increase', modal);
                });
            });
        }
    },
    
    updateImageGallery: async function(modal = false, variantId = ProductPage.getVariantFromUrl(ProductPage.productData).id, handle, modelInfoParts) {
        const { verticalGallery } = this;
        let mainCol, thumbCols;

        // Apply Loading Fade
        if (verticalGallery) {
            mainCol = verticalGallery.querySelector('.vertical-main-column');
            // Target the inner column so we don't accidentally wipe the scroll arrows
            thumbCols = verticalGallery.querySelectorAll('.vertical-thumbs-column-inner, .vertical-thumbs-row');

            if (mainCol) {
                mainCol.style.opacity = '0.4';
            }
            if (thumbCols.length) {
                thumbCols.forEach(col => col.style.opacity = '0.4');
            }

            // CSS transition to make it smooth
            if (mainCol) {
                mainCol.style.transition = 'opacity 0.2s ease';
            }
            if (thumbCols.length) {
                thumbCols.forEach(col => col.style.transition = 'opacity 0.2s ease');
            }
        }

        // Fetch image data. Pass layout context so the template knows which images to include.
        const isVerticalLayout = !!verticalGallery;
        let images = await Utility.fetchProductImages(handle, variantId, isVerticalLayout);

        let parentElement = modal ? Modal.parent : ProductPage.parent;
        if (!parentElement) parentElement = document;

        // Render UI and remove fade
        if (verticalGallery) {
            if (!mainCol || !thumbCols.length || !images || images.length === 0) {
                if (mainCol) {
                    mainCol.style.opacity = '1';
                }
                if (thumbCols.length) {
                    thumbCols.forEach((col) => {
                        col.style.opacity = '1';
                    });
                }
                return;
            }

            const mainImg = mainCol.querySelector('.vertical-main-img');
            const videoContainer = mainCol.querySelector('.persistent-video-main');
            let isVideoActive = videoContainer && (videoContainer.style.display === 'block' || (videoContainer.classList.contains('active-main-item') && videoContainer.style.display !== 'none'));

            if (isVideoActive) {
                const poster = videoContainer.querySelector('.custom-video-poster');
                if (poster) poster.style.display = 'flex';
                const videoEl = videoContainer.querySelector('video');
                if (videoEl) {
                    videoEl.pause();
                    videoEl.currentTime = 0;
                }
                videoContainer.classList.remove('active-main-item');
                videoContainer.style.display = 'none';
                isVideoActive = false;
            }
            if (mainImg) {
                mainImg.classList.add('active-main-item');
                mainImg.style.display = 'block';
            }

            if (mainImg) {
                // Determine if 'images' is an array of strings or array of objects
                const firstImgUrl = typeof images[0] === 'string' ? images[0] : images[0].src;
                mainImg.src = Utility.formatUrl(firstImgUrl, 1200);
            }

            thumbCols.forEach((container) => {
                const persistentVidThumbs = Array.from(container.querySelectorAll('.persistent-video-thumb, .persistent-video-thumb-mobile'));
                const persistentImgThumbs = Array.from(container.querySelectorAll('.persistent-product-thumb'));
                
                container.innerHTML = '';
                
                persistentVidThumbs.forEach(thumb => {
                    const thumbImg = thumb.querySelector('.vertical-thumb-img');
                    if (thumbImg) {
                        if (isVideoActive) thumbImg.classList.add('active');
                        else thumbImg.classList.remove('active');
                    }
                    container.appendChild(thumb);
                });

                let firstImgAssigned = false;
                images.forEach((imgData, index) => {

                    // Handle legacy string arrays vs object arrays with alt text
                    const imgUrl = typeof imgData === 'string' ? imgData : imgData.src;
                    const imgAlt = typeof imgData === 'string' ? '' : imgData.alt;

                    const imgEl = document.createElement('img');
                    imgEl.src = Utility.formatUrl(imgUrl, 300);
                    // Use actual alt text if available, fallback safely
                    imgEl.alt = imgAlt || '';
                    imgEl.className = 'vertical-thumb-img';
                    
                    if (!isVideoActive && !firstImgAssigned) {
                        imgEl.classList.add('active');
                        firstImgAssigned = true;
                    }

                    imgEl.width = 150;
                    imgEl.height = 200;
                    imgEl.setAttribute('data-thumbnail-id', index);
                    imgEl.style.cursor = 'pointer';

                    imgEl.addEventListener('click', (event) => {
                        this.updateSelectedImage(event.target, modal, verticalGallery);
                    });

                    container.appendChild(imgEl);
                });

                persistentImgThumbs.forEach((thumb, idx) => {
                    const newIndex = (images.length > 1 ? images.length : images.length) + idx;
                    thumb.setAttribute('data-thumbnail-id', newIndex);
                    
                    if (!isVideoActive && !firstImgAssigned) {
                        thumb.classList.add('active');
                        firstImgAssigned = true;
                    } else {
                        thumb.classList.remove('active');
                    }
                    container.appendChild(thumb);
                });

                // Remove the fade effect
                container.style.opacity = '1';
            });

            // Remove main image fade effect
            if (mainCol) mainCol.style.opacity = '1';

            // Update model info overlay when variant changes
            const modelInfoEl = mainCol ? mainCol.querySelector('.model-info p') : null;
            if (modelInfoEl) {
                if (modelInfoParts) {
                    modelInfoEl.textContent = `Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}`;
                    modelInfoEl.closest('.model-info').style.display = '';
                } else {
                    modelInfoEl.closest('.model-info').style.display = 'none';
                }
            }

            if (!modal) {
                ProductPage.thumbnailImages = verticalGallery.querySelectorAll('.vertical-thumb-img');
            }

            // Rebuild dots to reflect the new image count after a variant/swatch change
            const hasVideoForDots = !!videoContainer;
            const imageCountForDots = images.length;
            const productThumbsCount = verticalGallery.querySelectorAll('.vertical-thumbs-column-inner .persistent-product-thumb').length || 0;
            const totalImageCountForDots = imageCountForDots + productThumbsCount;
            const activeDotIndex = (isVideoActive && hasVideoForDots) ? 0 : (hasVideoForDots ? 1 : 0);
            
            this.rebuildGalleryDots(verticalGallery, hasVideoForDots, totalImageCountForDots, activeDotIndex);

            // Force scroll evaluation to update arrow visibility since DOM mutated
            setTimeout(() => {
                const innerCol = verticalGallery.querySelector('.vertical-thumbs-column-inner');
                if (innerCol) innerCol.dispatchEvent(new Event('scroll'));
                window.dispatchEvent(new Event('resize'));
            }, 100);

            return; // Exit early, vertical gallery is handled
        }

        // Standard Gallery
        const variantDetails = modal ? Modal.productDetails : ProductPage.productDetails; 
        if (variantDetails?.image && !images.includes(variantDetails.image)) {
            images = [variantDetails.image, ...images];
        }

        let selected;
        let thumbnails;
        let productData;
        let template;
        if (modal) {
            selected = Modal.selected;
            thumbnails = Modal.thumbnails;
            productData = Modal.productData;
        } else {
            selected = ProductPage.selected;
            thumbnails = ProductPage.thumbnails;
            productData = ProductPage.productData;
            template = ProductPage.templateSuffix;
        }

        if (!thumbnails || !selected) {
            return;
        }
    
        const imageEls = selected.querySelectorAll('img');
        imageEls.forEach((image) => {
            image.remove();
        });
        thumbnails.innerHTML = '';
        
        if ( window.innerWidth >= 1200) {
            // populate the HTML with the images
            images.forEach((image, index) => {
                if (index !== 0 && template == 'preview-pdp') {
                    return; // Skip all but the first image in preview-pdp template
                }
                let element = document.createElement('img');
                element.alt = productData.title;
                element.src = image;
                element.height = 800;

                if (index === 0) {
                    element.src = image.replace('&width=600', '&width=1200');
                    element.width = 1200;
                    selected.prepend(element.cloneNode(true));
                    const newDiv = document.createElement('div');
                    newDiv.classList.add('thumbnail-full-row');
                    newDiv.appendChild(element);
                    element = newDiv;
                    element.classList.add('active');
                    // Only add model info if Apparel and modelInfoParts exists
                    if (this.productType === 'Apparel' && modelInfoParts) {
                        const modelInfoDesktop = document.createElement('div');
                        const modelInfoMobile = document.createElement('div');

                        modelInfoDesktop.classList.add('model-info', 'desktop');
                        modelInfoDesktop.innerHTML = `<p>Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}</p>`;
                        modelInfoMobile.classList.add('model-info', 'mobile');
                        modelInfoMobile.innerHTML = `<p>Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}</p>`;
                        element.appendChild(modelInfoDesktop);
                        element.appendChild(modelInfoMobile);
                    }
                } else {
                    element.width = 600;
                }
                element.classList.add(`${modal ? 'modal-thumbnail' : 'thumbnail'}`);


                element.classList.add('product-thumbnail');

                element.setAttribute('data-thumbnail-id', index);
                element.setAttribute('tabindex', 0);
                element.setAttribute('role', 'button');
                element.setAttribute('aria-label', themeT('product.select_image'))
                element.addEventListener('click', (event) => {
                    this.updateSelectedImage(event.target, modal);
                });

                thumbnails.appendChild(element);
            });
            initializeGalleryEventListeners();
        } 
        else {
            images.forEach((image, index) => {
                const imgEl = document.createElement('img');
                
                imgEl.alt = productData.title;
                imgEl.src = image;
                imgEl.height = '800';
                imgEl.width = '600';
                imgEl.classList.add(`${modal ? 'modal-thumbnail' : 'thumbnail'}`);
                imgEl.classList.add('product-thumbnail');
                imgEl.setAttribute('data-thumbnail-id', index);
                imgEl.setAttribute('tabindex', 0);
                imgEl.setAttribute('role', 'button');
                imgEl.setAttribute('aria-label', themeT('product.select_image'));
                imgEl.addEventListener('click', (event) => {
                    this.updateSelectedImage(event.target, modal);
                });

                if (index === 0) {
                    // Add mobile hero image to .selected
                    selected.innerHTML = '';
                    const heroClone = imgEl.cloneNode(true);

                    heroClone.classList.add('mobile');
                    selected.appendChild(heroClone);
                    // Add mobile model info
                    if (this.productType === 'Apparel' && modelInfoParts) {
                        const container = document.createElement('div');
                        container.classList.add('model-info-container');

                        const modelInfoMobile = document.createElement('div');
                        modelInfoMobile.classList.add('model-info', 'mobile');
                        modelInfoMobile.innerHTML = `<p>Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}</p>`;

                        container.appendChild(modelInfoMobile);
                        selected.appendChild(container);
                    }

                    // Create .thumbnail-full-row for desktop layout in case of resizing
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('thumbnail', 'product-thumbnail', 'thumbnail-full-row');
                    wrapper.style.position = 'relative';
                    wrapper.style.display = 'flex';
                    wrapper.style.alignItems = 'center';

                    const desktopImg = imgEl.cloneNode(true);
                    desktopImg.src = desktopImg.src.replace(/(\?|&)width=600/, '&width=1200');
                    desktopImg.removeAttribute('class');
                    desktopImg.setAttribute('width', '100%');
                    desktopImg.setAttribute('height', 'auto');

                    wrapper.appendChild(desktopImg);

                    if (this.productType === 'Apparel' && modelInfoParts) {
                        const modelInfoDesktop = document.createElement('div');
                        modelInfoDesktop.classList.add('model-info', 'desktop');
                        modelInfoDesktop.innerHTML = `<p>Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}</p>`;
                        wrapper.appendChild(modelInfoDesktop);
                    }

                    thumbnails.appendChild(wrapper);
                }
                else {
                    // Other thumbnails
                    thumbnails.appendChild(imgEl);
                }
            });
            initializeGalleryEventListeners();
        }

        ProductPage.thumbnailImages = thumbnails.querySelectorAll('.thumbnail');
    },
    
    initImageGalleryEventListeners: function() {
        this.initKeyDownEventListeners();
        this.initArrowEventListeners();
    },
    
    initArrowEventListeners: function() {
      let modalView = false;
      let modal;
      if (typeof Modal !== 'undefined' && Modal) {
        modal = Modal.modal;
      }
      if (modal) {
        const modalStyle = window.getComputedStyle(modal);
        const modalDisplay = modalStyle.display;
        if (modalDisplay === 'block') {
          modalView = true;
        }
      }
      let parent;
      if (modalView) {
          parent = Modal.parent;
      } else {
          parent = document.querySelector('.product-imgs-container');
      }      
      if (!parent) {
        return;
      }
      const thumbnailArrows = parent.querySelectorAll('.thumbnail-arrow');
      if (thumbnailArrows.length > 0) {
        thumbnailArrows.forEach((arrow) => {
            arrow.addEventListener('click', () => {
            let clickedArrow = arrow;
            if (arrow.tagName !== 'SVG') {
                clickedArrow = arrow.querySelector('svg');
            }
            const direction = clickedArrow.dataset.icon;
            if (direction.includes('left')) {
                this.goToPreviousImage(modalView);
            } else if (direction.includes('right')) {
                this.goToNextImage(modalView);
            }
            });
        });
    }
    },
    
    initKeyDownEventListeners: function() {
      document.addEventListener('keydown', (event) => {
          let modalView = false;
          const {modal} = this;
          let modalStyle;
          let modalDisplay;
          if (modal) {
            modalStyle = window.getComputedStyle(modal);
            modalDisplay = modalStyle.display;
          }
          if (modalDisplay === 'block') {
            modalView = true;
          }
          if (event.key === 'ArrowRight') {
            this.goToNextImage(modalView);
          } else if (event.key === 'ArrowLeft') {
            this.goToPreviousImage(modalView);
          }
      });
    },
    
    goToNextImage: function(modal) {
      let thumbnails;
      let thumbnailContainer;
      if (modal) {
          thumbnails = Modal.thumbnailImages;
          thumbnailContainer = Modal.thumbnails;
      } else {
          thumbnails = ProductPage.thumbnailImages;
          thumbnailContainer = ProductPage.thumbnails;
      }
        if (!thumbnailContainer || !thumbnails || !thumbnails.length) {
            return;
        }
        const activeThumb = thumbnailContainer.querySelector('.active');
        if (!activeThumb) {
            return;
        }
        const currentIndex = activeThumb.dataset.thumbnailId;

        let nextIndex = (parseInt(currentIndex) + 1);

        if (nextIndex > thumbnails.length - 1) {
            nextIndex = 0;
            Utility.smoothScroll(thumbnailContainer, -(thumbnailContainer.scrollWidth - thumbnailContainer.clientWidth), 300);
        } else {
            Utility.smoothScroll(thumbnailContainer, 75, 300);
        }
        this.updateSelectedImage(thumbnails[nextIndex], modal);
    },
    
    goToPreviousImage: function(modal) {
        let thumbnails;
        let thumbnailContainer;
        if (modal) {
            thumbnails = Modal.thumbnailImages;
            thumbnailContainer = Modal.thumbnails;
        } else {
            thumbnails = ProductPage.thumbnailImages;
            thumbnailContainer = ProductPage.thumbnails;
        }
        if (!thumbnailContainer || !thumbnails || !thumbnails.length) {
            return;
        }
        const activeThumb = thumbnailContainer.querySelector('.active');
        if (!activeThumb) {
            return;
        }
        const currentIndex = activeThumb.dataset.thumbnailId;
        let prevIndex = (parseInt(currentIndex) - 1);

        if (prevIndex < 0) {
            prevIndex = thumbnails.length - 1;
            Utility.smoothScroll(thumbnailContainer, thumbnailContainer.scrollWidth - thumbnailContainer.clientWidth, 300);
        } else {
            Utility.smoothScroll(thumbnailContainer, -75, 300);
        }
        this.updateSelectedImage(thumbnails[prevIndex], modal);
    },
    
    updateSelectedImage: function(thumbnail, modal, explicitGalleryTarget = null) {
        // Derive the active vertical gallery instance to avoid global selector conflicts
        const activeVerticalGallery = explicitGalleryTarget || (thumbnail ? thumbnail.closest('.vertical-gallery-layout') : null) || this.verticalGallery;

        if (!thumbnail || !thumbnail.src) {
            console.warn('Invalid thumbnail passed to updateSelectedImage:', thumbnail);
            return;
        }

        // --- Check for vertical gallery ---
        if (activeVerticalGallery) {
            const imgSrc = thumbnail.src.replace(/&width=\d+/g, '').replace(/\?width=\d+&/g, '?').replace(/\?width=\d+$/, '');
            const finalImgSrc = imgSrc + (imgSrc.includes('?') ? '&' : '?') + 'width=1200';
            const altText = thumbnail.alt || '';

            const allVerticalThumbs = activeVerticalGallery.querySelectorAll('.vertical-thumb-img');
            allVerticalThumbs.forEach(thumb => thumb.classList.remove('active'));
            thumbnail.classList.add('active');

            const mainImg = activeVerticalGallery.querySelector('.vertical-main-img');
            if (mainImg) {
                mainImg.src = finalImgSrc;
                mainImg.alt = altText;
            }

            // Sync dots to reflect the active image
            const desktopColInner = activeVerticalGallery.querySelector('.vertical-thumbs-column-inner');
            if (desktopColInner) {
                const videoThumb = desktopColInner.querySelector('.persistent-video-thumb');
                const imgThumbs = Array.from(desktopColInner.querySelectorAll('.vertical-thumb-img:not(.persistent-video-thumb .vertical-thumb-img)'));
                const thumbPosition = imgThumbs.indexOf(thumbnail);
                if (thumbPosition >= 0) {
                    const dotIndex = videoThumb ? thumbPosition + 1 : thumbPosition;
                    this.syncGalleryDots(activeVerticalGallery, dotIndex);
                }
            }

            return; // Exit early
        }

        let selected;
        let thumbnails;
        if (modal) {
            selected = Modal.selected;
            thumbnails = Modal.thumbnailImages;
        } else {
            selected = ProductPage.selected;
            thumbnails = ProductPage.thumbnailImages;
        }

        if (!selected || !thumbnails || !thumbnails.length) {
            return;
        }

        const imgSrc = thumbnail.src.replace('&width=300', '').replace('&width=500', '');
        const altText = thumbnail.alt;

        thumbnails.forEach((thumb) => {
            thumb.classList.remove('active');
        });
        thumbnail.classList.add('active');

        const imgEls = selected.querySelectorAll('img');
        if (imgEls.length) {
            imgEls.forEach((el) => {
                el.src = imgSrc;
                el.alt = altText;
            });
        }
    },

    initVerticalGallery: function() {
        const { verticalGalleries } = this;
        if (!verticalGalleries || verticalGalleries.length === 0) return;
        
        verticalGalleries.forEach((galleryTarget) => {
            // Prevent double-binding if called multiple times
            if (galleryTarget.dataset.vgalInitialized) return;
            galleryTarget.dataset.vgalInitialized = 'true';

            // Cache persistent video and image thumb nodes scoped to this gallery instance
            const savedVidThumbsDesktop = Array.from(galleryTarget.querySelectorAll('.persistent-video-thumb'));
            const savedVidThumbsMobile = Array.from(galleryTarget.querySelectorAll('.persistent-video-thumb-mobile'));
            const savedMainVideos = Array.from(galleryTarget.querySelectorAll('.persistent-video-main'));
            const savedImgThumbsDesktop = Array.from(galleryTarget.querySelectorAll('.vertical-thumbs-column-inner .persistent-product-thumb, .vertical-thumbs-column .persistent-product-thumb'));
            const savedImgThumbsMobile = Array.from(galleryTarget.querySelectorAll('.vertical-thumbs-row .persistent-product-thumb'));

            // Universal handler for both mouse clicks and keyboard actions
            const handleGalleryInteraction = (e) => {
                // If keyboard event, only trigger on Spacebar, Enter, or Arrow keys
                if (e.type === 'keydown') {
                    const isArrowUp = e.key === 'ArrowUp';
                    const isArrowDown = e.key === 'ArrowDown';
                    const isArrowLeft = e.key === 'ArrowLeft';
                    const isArrowRight = e.key === 'ArrowRight';

                    if (isArrowUp || isArrowDown) {
                        // Navigate within the vertical desktop thumbnail column
                        const thumbCol = galleryTarget.querySelector('.vertical-thumbs-column-inner');
                        if (thumbCol && thumbCol.contains(e.target)) {
                            e.preventDefault();
                            const focusableItems = Array.from(
                                thumbCol.querySelectorAll('.vertical-thumb-video-wrapper, .vertical-thumb-img:not(.vertical-thumb-video-wrapper .vertical-thumb-img)')
                            );
                            const currentIndex = focusableItems.indexOf(document.activeElement);
                            if (currentIndex >= 0) {
                                const nextIndex = isArrowDown
                                    ? Math.min(currentIndex + 1, focusableItems.length - 1)
                                    : Math.max(currentIndex - 1, 0);
                                if (nextIndex !== currentIndex) {
                                    focusableItems[nextIndex].focus();
                                    focusableItems[nextIndex].click();
                                }
                            }
                            return;
                        }
                    }

                    if (isArrowLeft || isArrowRight) {
                        // Navigate slides from anywhere within the gallery
                        e.preventDefault();
                        this.shiftGallerySlide(galleryTarget, isArrowRight ? 1 : -1);
                        return;
                    }

                    if (e.key !== 'Enter' && e.key !== ' ') return;

                    // Prevent page from scrolling when hitting spacebar on a thumbnail
                    if (e.key === ' ' && e.target.closest('.vertical-thumb-video-wrapper, .vertical-thumb-img, .vertical-gallery-scroll-arrow, .vertical-gallery-dot')) {
                        e.preventDefault();
                    }
                }

                // Handle Dot clicks
                const dotBtn = e.target.closest('.vertical-gallery-dot');
                if (dotBtn) {
                    const dotsContainer = galleryTarget.querySelector('.vertical-gallery-dots');
                    const allDots = Array.from(dotsContainer?.querySelectorAll('.vertical-gallery-dot') || []);
                    const dotIndex = allDots.indexOf(dotBtn);
                    if (dotIndex >= 0) {
                        this.activateGallerySlide(galleryTarget, dotIndex);
                    }
                    return;
                }

                // Handle Custom Video Poster
                const videoPoster = e.target.closest('.custom-video-poster');
                if (videoPoster) {
                    videoPoster.style.display = 'none';
                    const videoElement = videoPoster.nextElementSibling;
                    if (videoElement && typeof videoElement.play === 'function') {
                        videoElement.muted = false;
                        videoElement.play();
                    }
                }

                // Handle Video vs Image logic
                const videoThumb = e.target.closest('.vertical-thumb-video-wrapper');
                const imgThumb = e.target.closest('.vertical-thumb-img:not(.vertical-thumb-video-wrapper .vertical-thumb-img)');
                
                const mainImg = galleryTarget.querySelector('.vertical-main-img');
                const allVideos = galleryTarget.querySelectorAll('.vertical-main-video-container');

                if (videoThumb) {
                    const videoId = videoThumb.getAttribute('data-thumbnail-id');
                    if (mainImg) mainImg.style.display = 'none';
                    allVideos.forEach(v => {
                        v.style.display = 'none';
                        v.querySelector('video')?.pause();
                    });
                    
                    const activeVideo = galleryTarget.querySelector(`[id="${videoId}"]`);
                    if (activeVideo) {
                        activeVideo.style.display = 'block';
                        
                        const poster = activeVideo.querySelector('.custom-video-poster');
                        if (poster) {
                            poster.style.display = 'flex';
                        }
                        
                        const videoEl = activeVideo.querySelector('video');
                        if (videoEl) {
                            videoEl.pause();
                            videoEl.currentTime = 0;
                        }
                    }
                    // Video is always dot index 0 when it exists
                    this.syncGalleryDots(galleryTarget, 0);
                } else if (imgThumb) {
                    allVideos.forEach(v => {
                        v.style.display = 'none';
                        v.querySelector('video')?.pause();
                    });
                    if (mainImg) mainImg.style.display = 'block';

                    // Trigger the global image update, passing modal context and the specific gallery root
                    const isModal = !!galleryTarget.closest('.pdp-modal, .quick-view-modal');
                    this.updateSelectedImage(imgThumb, isModal, galleryTarget);
                }

                // Handle Mobile Arrows
                const leftArrow = e.target.closest('.vertical-gallery-scroll-arrow.left-arrow');
                const rightArrow = e.target.closest('.vertical-gallery-scroll-arrow.right-arrow');
                const mobileRow = galleryTarget.querySelector('.vertical-thumbs-row');
                
                if (leftArrow && mobileRow) mobileRow.scrollBy({ left: -165, behavior: 'smooth' });
                if (rightArrow && mobileRow) mobileRow.scrollBy({ left: 165, behavior: 'smooth' });

                // Handle Desktop Arrows
                const upArrow = e.target.closest('.vertical-gallery-scroll-arrow.up-arrow');
                const downArrow = e.target.closest('.vertical-gallery-scroll-arrow.down-arrow');
                const desktopColInner = galleryTarget.querySelector('.vertical-thumbs-column-inner');
                
                if (upArrow && desktopColInner) desktopColInner.scrollBy({ top: -220, behavior: 'smooth' });
                if (downArrow && desktopColInner) desktopColInner.scrollBy({ top: 220, behavior: 'smooth' });
            };

            // Bind to both click and keydown for a11y support
            galleryTarget.addEventListener('click', handleGalleryInteraction);
            galleryTarget.addEventListener('keydown', handleGalleryInteraction);

            // Touch swipe on main column to shift slides on mobile
            const mainColumn = galleryTarget.querySelector('.vertical-main-column');
            if (mainColumn) {
                let touchStartX = 0;
                let touchStartY = 0;
                mainColumn.addEventListener('touchstart', (e) => {
                    touchStartX = e.touches[0].clientX;
                    touchStartY = e.touches[0].clientY;
                }, { passive: true });
                mainColumn.addEventListener('touchend', (e) => {
                    const deltaX = e.changedTouches[0].clientX - touchStartX;
                    const deltaY = e.changedTouches[0].clientY - touchStartY;
                    // Only handle clear horizontal swipes (min 40px, wider than vertical movement)
                    if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
                    const direction = deltaX < 0 ? 1 : -1;
                    this.shiftGallerySlide(galleryTarget, direction);
                }, { passive: true });
            }

            // Handle Mobile Arrow Visibility
            const mobileRow = galleryTarget.querySelector('.vertical-thumbs-row');
            if (mobileRow) {
                const checkOverflow = () => {
                    const leftArrow = galleryTarget.querySelector('.vertical-gallery-scroll-arrow.left-arrow');
                    const rightArrow = galleryTarget.querySelector('.vertical-gallery-scroll-arrow.right-arrow');
                    if (leftArrow && rightArrow) {
                        if (mobileRow.scrollWidth > mobileRow.clientWidth + 5) {
                            leftArrow.style.display = 'flex';
                            rightArrow.style.display = 'flex';
                        } else {
                            leftArrow.style.display = 'none';
                            rightArrow.style.display = 'none';
                        }
                    }
                };
                checkOverflow();
                window.addEventListener('resize', checkOverflow);
                setTimeout(checkOverflow, 500);
            }

            // Handle Desktop Arrow Visibility
            const desktopColInner = galleryTarget.querySelector('.vertical-thumbs-column-inner');
            if (desktopColInner) {
                const checkDesktopOverflow = () => {
                    const upArrow = galleryTarget.querySelector('.vertical-gallery-scroll-arrow.up-arrow');
                    const downArrow = galleryTarget.querySelector('.vertical-gallery-scroll-arrow.down-arrow');
                    if (upArrow && downArrow) {
                        if (desktopColInner.scrollHeight > desktopColInner.clientHeight + 5) {
                            if (desktopColInner.scrollTop > 5) {
                                upArrow.style.display = 'flex';
                            } else {
                                upArrow.style.display = 'none';
                            }

                            if (Math.ceil(desktopColInner.scrollTop + desktopColInner.clientHeight) < desktopColInner.scrollHeight - 5) {
                                downArrow.style.display = 'flex';
                            } else {
                                downArrow.style.display = 'none';
                            }
                        } else {
                            upArrow.style.display = 'none';
                            downArrow.style.display = 'none';
                        }
                    }
                };
                checkDesktopOverflow();
                desktopColInner.addEventListener('scroll', checkDesktopOverflow);
                window.addEventListener('resize', checkDesktopOverflow);
                setTimeout(checkDesktopOverflow, 500);
            }

            // MutationObserver exclusively for protecting video injections from Swatch wipes
            const observer = new MutationObserver(() => {
                const desktopCol = galleryTarget.querySelector('.vertical-thumbs-column-inner') || galleryTarget.querySelector('.vertical-thumbs-column');
                if (desktopCol && savedVidThumbsDesktop.length > 0 && !desktopCol.querySelector('.persistent-video-thumb')) {
                    savedVidThumbsDesktop.forEach(v => desktopCol.prepend(v));
                }
                if (desktopCol && savedImgThumbsDesktop.length > 0 && !desktopCol.querySelector('.persistent-product-thumb')) {
                    savedImgThumbsDesktop.forEach(v => desktopCol.appendChild(v));
                }

                const row = galleryTarget.querySelector('.vertical-thumbs-row');
                if (row && savedVidThumbsMobile.length > 0 && !row.querySelector('.persistent-video-thumb-mobile')) {
                    savedVidThumbsMobile.forEach(v => row.prepend(v));
                }
                if (row && savedImgThumbsMobile.length > 0 && !row.querySelector('.persistent-product-thumb')) {
                    savedImgThumbsMobile.forEach(v => row.appendChild(v));
                }

                const mainCol = galleryTarget.querySelector('.vertical-main-column');
                if (mainCol && savedMainVideos.length > 0 && !mainCol.querySelector('.persistent-video-main')) {
                    savedMainVideos.forEach(v => {
                        v.style.display = 'none';
                        mainCol.prepend(v);
                    });
                }
            });

            observer.observe(galleryTarget, { childList: true, subtree: true });
        });
    },

    syncGalleryDots: function(galleryTarget, activeDotIndex) {
        const dotsContainer = galleryTarget.querySelector('.vertical-gallery-dots');
        if (!dotsContainer) return;
        const allDots = dotsContainer.querySelectorAll('.vertical-gallery-dot');
        let activeDotEl = null;
        allDots.forEach((dot, index) => {
            const isActive = index === activeDotIndex;
            dot.classList.toggle('active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
            if (isActive) {
                activeDotEl = dot;
            }
        });
        if (activeDotEl) {
            const containerWidth = dotsContainer.offsetWidth;
            const dotLeft = activeDotEl.offsetLeft;
            const dotWidth = activeDotEl.offsetWidth;
            dotsContainer.scrollLeft = dotLeft - (containerWidth / 2) + (dotWidth / 2);
        }
    },

    rebuildGalleryDots: function(galleryTarget, hasVideo, imageCount, activeDotIndex) {
        const dotsContainer = galleryTarget.querySelector('.vertical-gallery-dots');
        if (!dotsContainer) return;
        const dotFill = dotsContainer.dataset.dotFill || '#222222';
        dotsContainer.style.setProperty('--dot-fill', dotFill);
        const totalDots = (hasVideo ? 1 : 0) + imageCount;
        dotsContainer.innerHTML = '';
        for (let i = 0; i < totalDots; i++) {
            const btn = document.createElement('button');
            btn.type = 'button';
            const isActive = i === activeDotIndex;
            btn.className = 'vertical-gallery-dot' + (isActive ? ' active' : '');
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            btn.setAttribute('aria-label', 'Slide ' + (i + 1));
            btn.innerHTML = `<span class="dot-state dot-state-empty" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="4.5" stroke="#222222"/></svg></span><span class="dot-state dot-state-active" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill="${dotFill}"/></svg></span>`;
            dotsContainer.appendChild(btn);
        }
    },

    activateGallerySlide: function(galleryTarget, dotIndex) {
        const desktopColInner = galleryTarget.querySelector('.vertical-thumbs-column-inner');
        if (!desktopColInner) return;
        const videoThumb = desktopColInner.querySelector('.persistent-video-thumb');
        const hasVideo = !!videoThumb;
        if (hasVideo && dotIndex === 0) {
            const mainImg = galleryTarget.querySelector('.vertical-main-img');
            const allVideos = galleryTarget.querySelectorAll('.vertical-main-video-container');
            if (mainImg) mainImg.style.display = 'none';
            allVideos.forEach(v => {
                v.style.display = 'none';
                v.querySelector('video')?.pause();
            });
            const activeVideo = galleryTarget.querySelector('[id="video-main"]');
            if (activeVideo) {
                activeVideo.style.display = 'block';
                const poster = activeVideo.querySelector('.custom-video-poster');
                if (poster) poster.style.display = 'flex';
            }
            const allThumbs = galleryTarget.querySelectorAll('.vertical-thumb-img');
            allThumbs.forEach(t => t.classList.remove('active'));
            const videoThumbImg = videoThumb.querySelector('.vertical-thumb-img');
            if (videoThumbImg) videoThumbImg.classList.add('active');
            this.syncGalleryDots(galleryTarget, 0);
            return;
        }
        const imgThumbs = Array.from(desktopColInner.querySelectorAll('.vertical-thumb-img:not(.persistent-video-thumb .vertical-thumb-img)'));
        const adjustedIndex = hasVideo ? dotIndex - 1 : dotIndex;
        const targetThumb = imgThumbs[adjustedIndex];
        if (!targetThumb) return;
        const allVideos = galleryTarget.querySelectorAll('.vertical-main-video-container');
        allVideos.forEach(v => {
            v.style.display = 'none';
            v.querySelector('video')?.pause();
        });
        const mainImg = galleryTarget.querySelector('.vertical-main-img');
        if (mainImg) mainImg.style.display = 'block';
        this.updateSelectedImage(targetThumb, false, galleryTarget);
        this.syncGalleryDots(galleryTarget, dotIndex);
    },

    shiftGallerySlide: function(galleryTarget, direction) {
        const dotsContainer = galleryTarget.querySelector('.vertical-gallery-dots');
        if (!dotsContainer) return;
        const allDots = Array.from(dotsContainer.querySelectorAll('.vertical-gallery-dot'));
        if (allDots.length === 0) return;
        const currentIndex = allDots.findIndex(dot => dot.classList.contains('active'));
        const resolvedCurrent = currentIndex < 0 ? 0 : currentIndex;
        const newIndex = Math.max(0, Math.min(allDots.length - 1, resolvedCurrent + direction));
        if (newIndex !== resolvedCurrent) {
            this.activateGallerySlide(galleryTarget, newIndex);
        }
    },

    _getEarlyAccessMap: function () {
        const script = document.getElementById('raw-variant-early-access');
        if (!script) return {};
        try {
            return JSON.parse(script.textContent);
        } catch {
            return {};
        }
    },

    _isVipOverlayDismissible: function () {
        return this.vipAccessOverlay?.dataset.vipOverlayDismissible === 'true';
    },

    showVipAccessOverlay: function () {
        if (!this.vipAccessOverlay) return;
        this.vipAccessOverlay.classList.remove('is-hidden');
        document.body.classList.add('vip-access-locked');
    },

    hideVipAccessOverlay: function () {
        if (!this.vipAccessOverlay) return;
        this.vipAccessOverlay.classList.add('is-hidden');
        document.body.classList.remove('vip-access-locked');
    },

    initVipAccessOverlay: function () {
        if (!this.vipAccessOverlay || !this._isVipOverlayDismissible()) {
            return;
        }

        if (this.vipAccessCloseBtn) {
            this.vipAccessCloseBtn.addEventListener('click', () => {
                this.dismissVipAccessOverlay();
            });
        }

        this._vipOverlayEscHandler = (event) => {
            if (event.key === 'Escape' && this.vipAccessOverlay && !this.vipAccessOverlay.classList.contains('is-hidden')) {
                this.dismissVipAccessOverlay();
            }
        };
        document.addEventListener('keydown', this._vipOverlayEscHandler);
    },

    dismissVipAccessOverlay: async function () {
        if (!this.vipAccessOverlay || !this._isVipOverlayDismissible()) {
            return;
        }

        this.hideVipAccessOverlay();
        await this.selectFirstNonEarlyAccessVariant();
    },

    selectFirstNonEarlyAccessVariant: async function () {
        let productData = typeof ProductPage !== 'undefined' ? ProductPage.productData : null;

        if (!productData?.variants?.length) {
            const handle = window.location.pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0];
            if (handle) {
                try {
                    productData = await Utility.fetchProductDataAjax(handle);
                } catch (error) {
                    console.error('Failed to fetch product data for early access fallback:', error);
                    return;
                }
            }
        }

        if (!productData?.variants?.length) return;

        const earlyAccessMap = this._getEarlyAccessMap();
        const publicVariant = productData.variants.find((variant) => {
            return earlyAccessMap[String(variant.id)] !== true && variant.available;
        }) || productData.variants.find((variant) => {
            return earlyAccessMap[String(variant.id)] !== true;
        });

        if (!publicVariant) return;

        const parent = this.productDetailsContainer || document;
        const optionValues = publicVariant.title.split(' / ').map((value) => value.trim());
        const selections = [];

        for (const value of optionValues) {
            const swatch = Array.from(parent.querySelectorAll('.swatch-btn')).find((element) => {
                return !element.closest('.sticky-atc-bar') && element.dataset.swatchValue === value;
            });

            if (swatch) {
                selections.push({ type: 'swatch', element: swatch });
                continue;
            }

            let matchedSelect = null;
            const selects = parent.querySelectorAll('select');
            for (const select of selects) {
                const matchingOption = Array.from(select.options).find((option) => {
                    return option.value === value || option.dataset.swatchValue === value;
                });

                if (matchingOption) {
                    matchedSelect = { select, matchingOption };
                    break;
                }
            }

            if (matchedSelect) {
                selections.push({ type: 'select', ...matchedSelect });
                continue;
            }

            return;
        }

        for (const selection of selections) {
            if (selection.type === 'swatch') {
                if (!selection.element.classList.contains('selected')) {
                    await this.handleSwatchChange(selection.element, false, false);
                }
            } else {
                selection.select.value = selection.matchingOption.value;
                selection.select.setAttribute('data-force-change', 'true');
                await this.handleSwatchChange(selection.select, false, false);
            }
        }
    },

    updateEarlyAccessRestriction: function (variantData, surface = {}) {
        const detailsContainer = this.productDetailsContainer;
        const isEligible = detailsContainer?.dataset.earlyAccessEligible === 'true';
        const isEarlyAccess = variantData?.earlyAccess === true;
        const isRestricted = isEarlyAccess && !isEligible;
        const { modal, card, addToCartBtn } = surface;

        if (modal || card) {
            if (!addToCartBtn) {
                return;
            }

            if (isRestricted) {
                addToCartBtn.disabled = true;
                addToCartBtn.classList.add('early-access-restricted', 'disabled-btn');
                addToCartBtn.classList.remove('out-of-stock');
                Shared.setButtonLabel(addToCartBtn, 'Early Access Only');
            } else {
                addToCartBtn.classList.remove('early-access-restricted', 'disabled-btn');
            }

            return;
        }

        if (this.atcContainer) {
            this.atcContainer.style.display = isRestricted ? 'none' : '';
        }

        if (this.shippingDelay) {
            if (isRestricted) {
                this.shippingDelay.style.display = 'none';
            } else {
                this.updateShippingDelay(variantData);
            }
        }

        if (this.membersOnlyContainer) {
            this.membersOnlyContainer.style.display = 'none';
        }

        if (this.vipAccessOverlay) {
            if (isRestricted) {
                this.showVipAccessOverlay();
            } else {
                this.hideVipAccessOverlay();
            }
        }

        if (this.stickyBar) {
            if (isRestricted) {
                this.stickyBar.style.display = 'none';
            } else {
                this.stickyBar.style.removeProperty('display');
            }
            if (this.stickyFab) {
                if (isRestricted) {
                    this.stickyFab.style.display = 'none';
                } else {
                    this.stickyFab.style.removeProperty('display');
                }
            }
        }
    },

    handleOutOfStock: async function (modal = false, variantId = ProductPage.getVariantFromUrl(ProductPage.productData).id) {
        let addToCartBtn;
        let productData;
        if (modal) {
            addToCartBtn = Modal.addToCartBtn;
            productData = Modal.productData;
        } else {
            addToCartBtn = ProductPage.addToCartBtn;
            productData = ProductPage.productData;
        }
        if (!productData) {
            return;
        }
        const { outOfStockBtn, stockAlert, inventoryBullet, backInStockInput, notifyContainer, notifyButton } = this;
        const variantDetails = await Utility.fetchProductDetails(productData.handle, variantId);

        // Logic to toggle Limited Edition vs Standard Back in Stock text/attributes
        if (notifyContainer && notifyButton && !modal) {
            // Check if global notify value overrides variant specific logic
            const isGlobalNotifyEnabled = notifyButton.dataset.source && notifyButton.dataset.source !== 'LimitedEditionPdp' && notifyButton.dataset.formType === 'notify';

            if (!isGlobalNotifyEnabled) {
                const domIsLimited = notifyContainer.dataset.isLimitedEdition === 'true';
                const isLimited = domIsLimited || variantDetails.limitedEdition;
                let limitMsg = notifyContainer.querySelector('.limited-edition-msg');

                if (isLimited) {
                    // Switch to Sign Up / Limited Edition State
                    if (!limitMsg) {
                        limitMsg = document.createElement('p');
                        limitMsg.classList.add('limited-edition-msg');
                        const limitedEditionMsgText = notifyContainer.dataset.limitedEditionMsg || "This limited-edition color went fast during presale! Don't miss out on the next special drop — sign up for email now to be the first to know.";
                        limitMsg.innerHTML = limitedEditionMsgText;
                        notifyContainer.prepend(limitMsg);
                    }
                    limitMsg.style.display = 'block';

                    // Ensure <br> exists and is visible
                    const nextEl = limitMsg.nextElementSibling;
                    if (!nextEl || nextEl.tagName !== 'BR') {
                        const br = document.createElement('br');
                        limitMsg.after(br);
                    } else {
                        nextEl.style.display = ''; // Unhide existing BR
                    }

                    // innerHTML (live edit on this branch) so translated labels render; keep the sr-only span.
                    const signUpSrText = notifyButton.querySelector('.patrol-sr-only');
                    notifyButton.innerHTML = themeT('product.sign_up');
                    if (signUpSrText) notifyButton.appendChild(signUpSrText);
                    notifyButton.dataset.formType = 'signUp';
                    notifyButton.dataset.source = 'LimitedEditionPdp';
                    notifyButton.id = 'email-signup-pdp';
                } else {
                    // Switch to Standard Back In Stock State
                    if (limitMsg) {
                        limitMsg.style.display = 'none';
                        // Hide the BR tag if it exists after the message
                        if (limitMsg.nextElementSibling && limitMsg.nextElementSibling.tagName === 'BR') {
                            limitMsg.nextElementSibling.style.display = 'none';
                        }
                    }

                    Shared.setButtonLabel(notifyButton, themeT('product.notify_when_available'));
                    notifyButton.dataset.formType = 'backInStock';
                    // Clear source if it was set to limited edition
                    if (notifyButton.dataset.source === 'LimitedEditionPdp') {
                        notifyButton.dataset.source = '';
                    }
                    notifyButton.id = 'back-in-stock-pdp';
                }
            }
        }

        let productAvailable = variantDetails.available;

        if (!productAvailable) {
            if (!modal) {
                if (addToCartBtn) {
                    addToCartBtn.style.display = 'none';
                }
                if (outOfStockBtn) {
                    outOfStockBtn.style.display = 'block';
                }
                if (stockAlert) {
                    stockAlert.style.fontWeight = '400';
                    stockAlert.textContent = themeT('product.notify_out_of_stock');
                }
                if (inventoryBullet) {
                    inventoryBullet.style.display = 'block';
                    inventoryBullet.style.color = 'red';
                }
                if (backInStockInput) {
                    backInStockInput.style.display = 'flex';
                }
                if (notifyContainer) {
                    notifyContainer.style.display = 'block';
                    notifyContainer.removeAttribute('aria-hidden');
                }
                if (notifyButton) {
                    notifyButton.style.display = '';
                }
            } else {
                if (addToCartBtn) {
                    if (!addToCartBtn.dataset.label) {
                        addToCartBtn.dataset.label = addToCartBtn.innerHTML || themeT('product.add_to_cart');
                    }
                    addToCartBtn.disabled = true;
                    addToCartBtn.classList.add('out-of-stock');
                    addToCartBtn.textContent = themeT('product.out_of_stock');
                }
            }
        } else {
            if (!modal) {
                if (addToCartBtn) {
                    addToCartBtn.style.display = 'block';
                }
                if (outOfStockBtn) {
                    outOfStockBtn.style.display = 'none';
                }
                if (stockAlert) {
                    if (variantDetails.shippingDelay != "") {
                        stockAlert.textContent = themeT('cart.shipping_delay_note', { delay: variantDetails.shippingDelay });
                        stockAlert.style.fontWeight = '700';
                    } else {
                        stockAlert.style.fontWeight = '400';
                        if (ProductPage.stockAlert === 'low') {
                            if (variantDetails.inventory == undefined || variantDetails.inventory > 10 || variantDetails.inventory < 1) {
                                stockAlert.textContent = '';
                                if (inventoryBullet) {
                                    inventoryBullet.style.display = 'none';
                                }
                            } else {
                                stockAlert.innerHTML = themeT('product.stock_hot', { count: variantDetails.inventory });
                                if (inventoryBullet) {
                                    inventoryBullet.style.display = 'block';
                                    inventoryBullet.style.color = 'red';
                                }
                            }
                        } else if (ProductPage.stockAlert === 'all') {
                            if (variantDetails.inventory == undefined || variantDetails.inventory > 10 || variantDetails.inventory < 1) {
                                stockAlert.textContent = themeT('product.in_stock_ready');
                                if (inventoryBullet) {
                                    inventoryBullet.style.display = 'block';
                                    inventoryBullet.style.color = 'green';
                                }
                            } else {
                                stockAlert.innerHTML = themeT('product.stock_hot', { count: variantDetails.inventory });
                                if (inventoryBullet) {
                                    inventoryBullet.style.display = 'block';
                                    inventoryBullet.style.color = 'red';
                                }
                            }
                        }
                    }
                }
                if (backInStockInput) {
                    backInStockInput.style.display = 'none';
                }
                if (notifyContainer) {
                    notifyContainer.style.display = 'none';
                    notifyContainer.setAttribute('aria-hidden', 'true');
                }
                if (notifyButton) {
                    notifyButton.style.display = 'none';
                }
            } else {
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    addToCartBtn.classList.remove('out-of-stock');
                    addToCartBtn.innerHTML = addToCartBtn.dataset.label || themeT('product.add_to_cart');
                }
            }
        }

        // Keep shipping delay in sync on first load and after variant changes.
        // handleOutOfStock runs from ProductPage.init, so this covers refresh/deep links
        // (not only swatch clicks in handleSwatchChange).
        this.updateShippingDelay(variantDetails);

        if (modal) {
            this.updateEarlyAccessRestriction(variantDetails, { modal: true, addToCartBtn });
        } else {
            this.updateEarlyAccessRestriction(variantDetails);
        }

        // Run Loop Exclusion Logic after Stock Logic to ensure overrides work correctly
        if (!modal) {
            this.checkLoopExclusions(variantId, modal, productAvailable);
        }
    },

    updateShippingDelay: function (variantData) {
        if (!this.shippingDelay || !variantData) return;

        const shippingDelay = variantData.shippingDelay;
        // Text lives in a nested span (next to the truck icon) so we don't
        // clobber the icon when updating the message.
        const shippingDelayTextEl = this.shippingDelay.querySelector('.shipping-delay__text');

        if (shippingDelay && variantData.available) {
            const prefix = this.shippingDelay.dataset.defaultText || themeT('cart.shipping_delay_note', { delay: '' });
            if (shippingDelayTextEl) {
                shippingDelayTextEl.textContent = prefix + shippingDelay;
            } else {
                this.shippingDelay.textContent = prefix + shippingDelay;
            }
            this.shippingDelay.style.display = '';

            if (this.shippingDelayInput) {
                this.shippingDelayInput.value = shippingDelay;
                this.shippingDelayInput.disabled = false;
            }
        } else {
            this.shippingDelay.style.display = 'none';

            if (this.shippingDelayInput) {
                this.shippingDelayInput.value = '';
                this.shippingDelayInput.disabled = true;
            }
        }
    },

    // Swaps the promotion line and its fallback (returns text) for the selected variant.
    updatePromoText: function (variantData) {
        if (!variantData) {
            return;
        }

        // The PDP can render the promo block more than once (one per layout)
        const promoBlocks = document.querySelectorAll('[data-promo-block]');
        promoBlocks.forEach((promoBlock) => {
            if (promoBlock.dataset.productHandle !== variantData.handle) {
                return;
            }

            // Each placement only shows promos whose position matches it
            const hasPromo = Boolean(variantData.promoText) && variantData.promoPosition === promoBlock.dataset.promoPosition;
            const promoTextEl = promoBlock.querySelector('[data-promo-text]');
            const promoFallbackEl = promoBlock.querySelector('[data-promo-fallback]');

            if (promoTextEl) {
                // Promo text can contain links, same as the Liquid render
                promoTextEl.innerHTML = hasPromo ? variantData.promoText : '';
                promoTextEl.hidden = !hasPromo;
            }
            if (promoFallbackEl) {
                promoFallbackEl.hidden = hasPromo;
            } else {
                // No fallback to show, so hide the whole block to avoid an empty flex gap
                promoBlock.hidden = !hasPromo;
            }
        });
    },

    initSwatchesStock: async function (productData, modal=false, curVariant = ProductPage.getVariantFromUrl(ProductPage.productData).id) {
        let parent;
        if (modal) {
            parent = Modal.parent;
        } else {
            parent = ProductPage.parent;
        }
        if (!parent) {
            return;
        }
        let selectedSwatch = parent.querySelector('.swatch-btn.selected');
        if (!selectedSwatch) {
            const select = parent.querySelector('select.swatch-btn, select[data-option-name]');
            if (select && select.selectedOptions[0]) {
                selectedSwatch = select.selectedOptions[0];
            }
        }
        if (!selectedSwatch) {
            return;
        }
        const optionNameHandle = Utility.shopifyHandleize(selectedSwatch.dataset.optionName);
        // updateSwatchesExist must run before updateSwatchesStock — it removes .disabled
        // from existing-but-OOS swatches, which updateSwatchesStock then re-applies correctly.
        this.updateSwatchesExist(selectedSwatch.dataset.swatchValue, optionNameHandle, modal);
        this.updateSwatchesStock(selectedSwatch.dataset.swatchValue, optionNameHandle, modal);
    },
    
    generateCombinations: function(options, optionIndex = 0, previousCombination = []) {
        if (optionIndex === options.length) {
            return [previousCombination];
        }
    
        const allCombinations = [];
        const currentOption = options[optionIndex];
    
        currentOption.values.forEach(value => {
            const newCombination = [...previousCombination, value];
            const combinationsFromHere = this.generateCombinations(options, optionIndex + 1, newCombination);
            allCombinations.push(...combinationsFromHere);
        });
    
        return allCombinations;
    },
    
    updateSwatchesStock: async function (swatchValue, optionNameHandle, modal = false, card = null, context = null) {
        let parent;
        let productData;
        let allSwatches;

        if (context) {
            parent = context.parent;
            productData = context.productData;
        } else if (modal) {
            parent = Modal.parent;
            productData = Modal.productData;
            allSwatches = Modal.allSwatches;
        } else if (card) {
            parent = card;
            productData = parent.productData || ProductCards.productData;
        } else {
            parent = ProductPage.parent;
            productData = ProductPage.productData;
            allSwatches = ProductPage.allSwatches;
        }
        
        if (!parent || !productData) {
            return;
        }

        if (!allSwatches) {
            allSwatches = parent.querySelectorAll('.swatch-btn');
        }
        
        let outOfStock = [];
        const allOpts = productData.options;
        const optsCount = allOpts.length;
        let lastOptionSwatches;

        if (optsCount === 1) {
            lastOptionSwatches = Array.from(allSwatches).filter(btn => !btn.closest('.sticky-atc-bar'));
            const swatchValues = productData.options[0].values;
            productData.variants.forEach((variant) => {
                const variantTitleOpts = variant.title.split(' / ').map(v => v.trim());

                swatchValues.forEach((value) => {
                    if (variantTitleOpts.includes(value.trim())) {
                        let inStock = variant.available;
                        if (!inStock) {
                            outOfStock.push(value);
                        }
                    }
                });
            });
        } else {
            const lastOption = productData.options[optsCount - 1];

            // Normalize the localized name so it matches the HTML data-attribute
            const lastOptionHandle = Utility.canonicalOptionHandle(lastOption.name);

            // Get selected values for other options, filtering strictly by the handleized name
            const currentSelections = Array.from(parent.querySelectorAll('.swatch-btn.selected'))
                .filter(swatch => !swatch.closest('.sticky-atc-bar') && swatch.dataset.optionName !== lastOptionHandle)
                .map(swatch => swatch.dataset.swatchValue.trim());

            // Try selecting swatches for the target option using the handleized name
            lastOptionSwatches = Array.from(parent.querySelectorAll(`.swatch-btn[data-option-name="${lastOptionHandle}"]`))
                .filter(swatch => !swatch.closest('.sticky-atc-bar'));

            // Fallback: manual filter by option name if selector fails
            if (lastOptionSwatches.length === 0) {
                lastOptionSwatches = Array.from(parent.querySelectorAll('.swatch-btn'))
                    .filter(btn => !btn.closest('.sticky-atc-bar') && btn.dataset.optionName === lastOptionHandle);
            }

            lastOptionSwatches.forEach(swatch => {
                // Build variant combination to test
                const testCombination = [...currentSelections, swatch.dataset.swatchValue.trim()].filter(Boolean);

                const matchingVariant = productData.variants.find(variant => {
                    // Trim title parts for clean comparison
                    const variantTitleParts = variant.title.split(' / ').map(v => v.trim());
                    return testCombination.every(option => variantTitleParts.includes(option));
                });

                // Check availability. If variant doesn't exist or is unavailable, mark out of stock.
                if (matchingVariant) {
                    let inStock = matchingVariant.available;
                    if (!inStock) {
                        outOfStock.push(swatch.dataset.swatchValue);
                    }
                } else {
                    outOfStock.push(swatch.dataset.swatchValue);
                }
            });
        }

        // Update UI state based on availability
        if (lastOptionSwatches && lastOptionSwatches.length) {
            lastOptionSwatches.forEach((swatch) => {
            const isOOS = outOfStock.includes(swatch.dataset.swatchValue);

            if (isOOS) {
                swatch.classList.add('disabled');
                // Update dropdown options text
                if (swatch.tagName === 'OPTION') {
                    swatch.disabled = true;
                    if (!swatch.textContent.includes(themeT('product.option_out_of_stock'))) {
                        swatch.textContent += themeT('product.option_out_of_stock');
                    }
                }
            } else {
                swatch.disabled = false;
                swatch.classList.remove('disabled');
                // Restore dropdown options text
                if (swatch.tagName === 'OPTION') {
                    swatch.textContent = swatch.textContent.replace(themeT('product.option_out_of_stock'), '');
                }
            }

            const stickyBarEl = document.querySelector('.sticky-atc-bar');
            if (stickyBarEl && !modal && !card && !context) {
                const stickyOptionHandle = swatch.dataset.optionName;
                const stickySwatch = stickyBarEl.querySelector(`.swatch-btn[data-option-name="${stickyOptionHandle}"][data-swatch-value="${swatch.dataset.swatchValue}"]`);
                if (stickySwatch) {
                    if (isOOS) {
                        stickySwatch.classList.add('disabled');
                    } else {
                        stickySwatch.classList.remove('disabled');
                    }
                }
            }
            });
        }
    },

    
    variantExistsForCombination: function(combination, variants) {
        return variants.some(variant => {
            const variantOptions = variant.title.split(' / ').map(v => v.trim());
            return combination.every(value => variantOptions.includes(value));
        });
    },

    updateSwatchesExist: function(swatchValue, optionNameHandle, modal = false, card = false, context = null) {
        let productData;
        let parent;

        if (context) {
            parent = context.parent;
            productData = context.productData;
        } else if (modal) {
            productData = Modal.modalProductData;
            parent = Modal.parent;
        } else if (card) {
            parent = card;
            productData = parent.productData || ProductCards.productData; // Read isolated data
        } else {
            productData = ProductPage.productData;
            parent = ProductPage.parent;
        }

        if (!parent || !productData) {
            return;
        }

        const options = productData.options || [];

        // Return if there are no relevant options
        if (options.length <= 1) {
            return;
        }
    
        // Select all swatches, explicitly excluding the sticky bar to prevent ghost clicks
        const allSwatches = Array.from(parent.querySelectorAll('.swatch-btn')).filter(btn => !btn.closest('.sticky-atc-bar'));

        // Normalize localized option names to canonical handles for consistent matching
        const optionHandles = options.map(option => Utility.canonicalOptionHandle(option.name));

        // Evaluate existence for each option group independently
        optionHandles.forEach((currentOptionHandle) => {
            // All swatches for the option being evaluated
            const currentOptionSwatches = allSwatches.filter(
                btn => btn.dataset.optionName === currentOptionHandle
            );

            if (!currentOptionSwatches.length) {
                return;
            }

            // Gather selected values from all other option groups
            const selectedForOtherOptions = optionHandles
                .filter(handle => handle !== currentOptionHandle)
                .map((handle) => {
                    const selectedBtn = allSwatches.find(
                        btn =>
                            btn.dataset.optionName === handle &&
                            btn.classList.contains('selected')
                    );
                    return selectedBtn ? selectedBtn.dataset.swatchValue : null;
                })
                .filter(Boolean);

            const unavailableValues = [];

            // Test each swatch value against existing variants
            currentOptionSwatches.forEach((swatch) => {
                const testCombination = [
                    ...selectedForOtherOptions,
                    swatch.dataset.swatchValue,
                ];

                // If no variant exists for this combination, mark it unavailable
                if (!this.variantExistsForCombination(testCombination, productData.variants)) {
                    unavailableValues.push(swatch.dataset.swatchValue);
                }
            });

            // Update UI state based on existence results
            currentOptionSwatches.forEach((swatch) => {
                const isUnavailable = unavailableValues.includes(
                    swatch.dataset.swatchValue
                );

                swatch.disabled = isUnavailable;

                // Use class-based hiding and disabled styling to avoid layout side-effects
                if (isUnavailable) {
                    swatch.classList.add('hide-swatch');
                    swatch.classList.add('disabled');
                } else {
                    swatch.classList.remove('hide-swatch');
                    swatch.classList.remove('disabled');
                }

                const stickyBarEl = document.querySelector('.sticky-atc-bar');
                if (stickyBarEl && !modal && !card && !context) {
                    const stickySwatch = stickyBarEl.querySelector(`.swatch-btn[data-option-name="${currentOptionHandle}"][data-swatch-value="${swatch.dataset.swatchValue}"]`);
                    if (stickySwatch) {
                        stickySwatch.disabled = isUnavailable;
                        if (isUnavailable) {
                            stickySwatch.classList.add('hide-swatch', 'disabled');
                        } else {
                            stickySwatch.classList.remove('hide-swatch', 'disabled');
                        }
                    }
                }

                // Dropdown support
                if (swatch.tagName === 'OPTION') {
                    if (isUnavailable) {
                        if (!swatch.textContent.includes(themeT('product.option_unavailable'))) {
                            swatch.textContent += themeT('product.option_unavailable');
                        }
                    } else {
                        swatch.textContent = swatch.textContent.replace(
                            themeT('product.option_unavailable'),
                            ''
                        );
                    }
                }
            });

            // If the currently selected swatch is now invalid,
            // force the first available swatch in this option group
            const currentlySelected = currentOptionSwatches.find(btn =>
                btn.classList.contains('selected') || (btn.tagName === 'OPTION' && btn.selected)
            );

            const selectedValue = currentlySelected
                ? currentlySelected.dataset.swatchValue
                : null;

            if (!selectedValue || unavailableValues.includes(selectedValue)) {
                const firstAvailable = currentOptionSwatches.find(
                    btn => !btn.disabled && !btn.classList.contains('hide-swatch')
                );

                if (firstAvailable && firstAvailable.dataset.swatchValue !== selectedValue) {
                    // Break the synchronous call stack using a debounce
                    // Scoped to the specific parent form/card to prevent cross-card blocking
                    if (!parent._swatchCorrectionTimers) parent._swatchCorrectionTimers = {};
                    
                    if (!parent._swatchCorrectionTimers[currentOptionHandle]) {
                        parent._swatchCorrectionTimers[currentOptionHandle] = setTimeout(() => {
                            parent._swatchCorrectionTimers[currentOptionHandle] = null;
                            
                            if (firstAvailable.tagName === 'OPTION') {
                                const select = firstAvailable.closest('select');
                                select.value = firstAvailable.value;
                                select.dispatchEvent(new Event('change', { bubbles: true }));
                            } else {
                                firstAvailable.click();
                            }
                        }, 50);
                    }
                }
            }

            // Handle select dropdown fallback
            const dropdownSwatch = currentOptionSwatches.find(
                swatch => swatch.tagName === 'OPTION'
            );

            if (dropdownSwatch) {
                const select = dropdownSwatch.closest('select');
                if (select) {
                    const allOptions = Array.from(select.options);
                    const selectedOpt = allOptions.find(
                        opt => opt.value === select.value
                    );

                    if (selectedOpt && selectedOpt.disabled) {
                        select.setAttribute('data-force-change', true);

                        const firstAvailableOption = allOptions.find(
                            opt => !opt.disabled
                        );

                        if (firstAvailableOption) {
                            // Break the synchronous call stack using a debounce
                            // Scoped to the specific parent form/card to prevent cross-card blocking
                            if (!parent._swatchCorrectionTimers) parent._swatchCorrectionTimers = {};
                            
                            if (!parent._swatchCorrectionTimers[currentOptionHandle + '_select']) {
                                parent._swatchCorrectionTimers[currentOptionHandle + '_select'] = setTimeout(() => {
                                    parent._swatchCorrectionTimers[currentOptionHandle + '_select'] = null;
                                    
                                    select.value = firstAvailableOption.value;

                                    const event = new Event('change', {
                                        bubbles: true,
                                        cancelable: true,
                                    });
                                    select.dispatchEvent(event);
                                }, 50);
                            }
                        }
                    }
                }
            }
        });
    },

    handleSwatchChange: async function (swatch, modal = false, card = false, context = null) {
        // Prevent sticky bar swatches from executing duplicate form logic
        if (swatch && typeof swatch.closest === 'function' && swatch.closest('.sticky-atc-bar')) {
            return;
        }

        let parent;
        let productData;
        let variantIdInput;
        let addToCartBtn;
        let fixedAddToCartBtn;
        let prices;
        let urls;

        let announcementBar;

        let productTitleH1s;
        let retired;
        let ogTitleWithShape;
        let ogImage;
        let ogImageSecureUrl;
        let behindProdAcc;
        let featuresAcc;
        let techSpecsAcc;
        let detailsCareAcc;
        let customizeBtn;

        if (typeof ProductPage !== 'undefined') {
            ({
                productTitleH1s,
                ogTitleWithShape,
                ogImage,
                ogImageSecureUrl,
                behindProdAcc,
                featuresAcc,
                techSpecsAcc,
                detailsCareAcc,
                retired,
                customizeBtn,
                announcementBar
            } = ProductPage);
        }

        if (context) {
            parent = context.parent;
            productData = context.productData;
        } else if (modal) {
            variantIdInput = Modal.idInput;
            parent = Modal.parent;
            addToCartBtn = Modal.addToCartBtn;
            productData = Modal.productData;
            prices = parent.querySelector('.prices');
        } else if (card) {
            parent = swatch.closest('.product-card');
            if (!parent) return;

            addToCartBtn = parent.querySelector('.quick-add');
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
            }

            prices = parent.querySelector('.prices');

            urls = parent.querySelectorAll('.product-url');

            // If a user clicks an inner image or span, traverse up to the 
            // parent button/option to safely read its data attributes.
            let swatchTarget = swatch;
            if (swatch.tagName === 'IMG' || swatch.tagName === 'SPAN') {
                swatchTarget = swatch.closest('.swatch-btn') || swatch.closest('button');
            } else if (swatch.tagName === 'SELECT') {
                swatchTarget = swatch.selectedOptions[0];
            } else if (swatch.tagName !== 'BUTTON' && swatch.tagName !== 'OPTION') {
                // Final fallback for any other unexpected nested elements
                swatchTarget = swatch.closest('.swatch-btn') || swatch;
            }

            const handle = swatchTarget.dataset.handle;

            try {
                productData = await Utility.fetchProductDataAjax(handle);
                ProductCards.productData = productData; // Keep for legacy support
                parent.productData = productData; // Attach data securely to this specific card
            } catch (error) {
                console.error('Error fetching product data:', error);
                return;
            }
          
            variantIdInput = parent.querySelector('.var-id');   
        } else {
            variantIdInput = ProductPage.idInput;
            parent = ProductPage.parent;
            addToCartBtn = ProductPage.addToCartBtn;
            fixedAddToCartBtn = ProductPage.fixedAddToCartBtn?.querySelector('.fixed-add-to-cart-btn');
            productData = ProductPage.productData;
            prices = ProductPage.pricesMain;
        }

        let selectedOptions = [];
        const quantitySelector = parent ? parent.querySelector('.quantity') : null;
        let selectedBtn = swatch;
        let select;

        if (selectedBtn.tagName === 'IMG' || selectedBtn.tagName === 'SPAN') {
            selectedBtn = selectedBtn.closest('.swatch-btn') || selectedBtn.closest('button');
        } else if (selectedBtn.tagName === 'SELECT') {
            select = selectedBtn;
            selectedBtn = selectedBtn.selectedOptions[0];
        } else if (selectedBtn.tagName === 'OPTION') {
            select = selectedBtn.closest('select');
        } else if (selectedBtn.tagName !== 'BUTTON') {
            selectedBtn = selectedBtn.closest('.swatch-btn') || selectedBtn;
        }

        const optionName = selectedBtn.dataset.optionName;
        const swatchValue = selectedBtn.dataset.swatchValue;
        const optionNameHandle = Utility.shopifyHandleize(optionName);

        if (optionNameHandle === 'color') {
            const isLimited = selectedBtn.dataset.isLimited === 'true';
            const limitedSwatchText = parent.querySelector(`#${optionNameHandle}-limited-selected`);
            const coreSwatchText = parent.querySelector(`#${optionNameHandle}-core-selected`);
            const limitedColorLabel = parent.querySelector('.limited-color-label');
            const coreColorLabel = parent.querySelector('.core-color-label');

            if (isLimited) {
                if (limitedSwatchText) {
                    limitedSwatchText.textContent = swatchValue;
                }
                if (limitedColorLabel) {
                    limitedColorLabel.textContent = limitedColorLabel.dataset.baseLabel + ': ';
                }
                if (coreSwatchText) {
                    coreSwatchText.textContent = '';
                }
                if (coreColorLabel) {
                    coreColorLabel.textContent = coreColorLabel.dataset.baseLabel;
                }
            } else {
                if (coreSwatchText) {
                    coreSwatchText.textContent = swatchValue;
                }
                if (coreColorLabel) {
                    coreColorLabel.textContent = coreColorLabel.dataset.baseLabel + ': ';
                }
                if (limitedSwatchText) {
                    limitedSwatchText.textContent = '';
                }
                if (limitedColorLabel) {
                    limitedColorLabel.textContent = limitedColorLabel.dataset.baseLabel;
                }
            }
        } else {
            const selectedSwatchText = parent.querySelector(`#${optionNameHandle}-selected`);
            if (selectedSwatchText) {
                selectedSwatchText.textContent = swatchValue;
            }
        }

        // Sync the Sticky ATC bar UI when the main product form swatches change
        if (this.stickyBar && !context) {
            const stickyBarEl = document.querySelector('.sticky-atc-bar');

            if (stickyBarEl) {
                if (optionNameHandle === 'shape') {
                    if (this.stickyShapeBtns && this.stickyShapeBtns.length > 0) {
                        this.stickyShapeBtns.forEach((btn) => {
                            if (btn.getAttribute('data-swatch-value') === swatchValue) {
                                btn.classList.add('is-active', 'selected');
                            } else {
                                btn.classList.remove('is-active', 'selected');
                            }
                        });
                    }
                    if (this.stickyShapeLabelText) {
                        this.stickyShapeLabelText.textContent = swatchValue;
                    }
                } else if (optionNameHandle === 'color') {
                    if (this.stickyColorBtns && this.stickyColorBtns.length > 0) {
                        this.stickyColorBtns.forEach((btn) => {
                            if (btn.getAttribute('data-swatch-value') === swatchValue) {
                                btn.classList.add('is-active', 'selected');
                            } else {
                                btn.classList.remove('is-active', 'selected');
                            }
                        });
                    }

                    const isLimited = selectedBtn.dataset.isLimited === 'true';
                    const stickyLimitedLabel = stickyBarEl.querySelector('.sticky-atc-selected-color-text[data-type="limited"]');
                    const stickyCoreLabel = stickyBarEl.querySelector('.sticky-atc-selected-color-text[data-type="core"]');

                    if (isLimited) {
                        if (stickyLimitedLabel) {
                            stickyLimitedLabel.textContent = swatchValue;
                            if (stickyLimitedLabel.previousElementSibling) {
                                stickyLimitedLabel.previousElementSibling.textContent = stickyLimitedLabel.previousElementSibling.dataset.baseLabel + ': ';
                            }
                        }
                        if (stickyCoreLabel) {
                            stickyCoreLabel.textContent = '';
                            if (stickyCoreLabel.previousElementSibling) {
                                stickyCoreLabel.previousElementSibling.textContent = stickyCoreLabel.previousElementSibling.dataset.baseLabel;
                            }
                        }
                    } else {
                        if (stickyCoreLabel) {
                            stickyCoreLabel.textContent = swatchValue;
                            if (stickyCoreLabel.previousElementSibling) {
                                stickyCoreLabel.previousElementSibling.textContent = stickyCoreLabel.previousElementSibling.dataset.baseLabel + ': ';
                            }
                        }
                        if (stickyLimitedLabel) {
                            stickyLimitedLabel.textContent = '';
                            if (stickyLimitedLabel.previousElementSibling) {
                                stickyLimitedLabel.previousElementSibling.textContent = stickyLimitedLabel.previousElementSibling.dataset.baseLabel;
                            }
                        }
                    }
                }
            }
        }

        if ((select && select.getAttribute('data-force-change') !== 'true') || !select) {
            selectedOptions = this.updateSelectedSwatches(parent, optionNameHandle, selectedBtn, card, modal);
            this.updateSwatchesExist(swatchValue, optionNameHandle, modal, card ? parent : false, context);
        } else if (select && select.getAttribute('data-force-change') == 'true') {
            select.setAttribute('data-force-change', false);
            // Fallback for safety to get selected options if forced change bypassed update
            const activeSwatches = Array.from(parent.querySelectorAll('.swatch-btn.selected')).filter(el => !el.closest('.sticky-atc-bar'));
            selectedOptions = activeSwatches.map(s => s.dataset.swatchValue);
        }

        const saveBtn = parent.querySelector('.save-btn');
        if (saveBtn) {
            saveBtn.disabled = true;
        }

        const matchingVariant = productData.variants.find((variant) => {
            // Split by ' / ' to keep sizes like 'M6/W8' or 'XS/S' intact
            const variantAttributes = variant.title.split(' / ').map(attr => attr.trim().toLowerCase());

            // Normalize selected options (lowercase only)
            // REMOVED: The special 'Slide/Recovery' splitting logic is no longer needed
            const normalizedSelectedOptions = selectedOptions.map(option => option.toLowerCase());

            // Check for match
            const isMatch = normalizedSelectedOptions.every(option => {
                return variantAttributes.some(variantAttr => variantAttr === option);
            });

            return isMatch;
        });

        if (!matchingVariant) {
            console.error('No matching variant found for selected options:', selectedOptions);
            return;
        }

        // Update the dynamic background style mapped via variant metafields on main templates.
        if (!modal && !card && !context) {
            this.updateDynamicBackground(matchingVariant.id);
        }

        // If context exists, we only need to fire callback and update stock logic for PFA
        if (context) {
            if (typeof context.onVariantChange === 'function') {
                await context.onVariantChange(matchingVariant);
            }
            await this.updateSwatchesStock(swatchValue, optionNameHandle, false, null, context);
            return;
        }

        // Track the latest selection so a slower earlier response does not overwrite the promo
        if (!modal && !card) {
            this.latestPromoVariantId = matchingVariant.id;
        }

        const variantData = await Utility.fetchProductDetails(productData.handle, matchingVariant.id);
        if (modal) {
            Modal.productDetails = variantData;
        } else if (!card) {
            ProductPage.productDetails = variantData;
        }

        const limitedEditionLabel = parent.querySelector('[data-limited-edition-label]');
        if (limitedEditionLabel) {
            if (variantData.limitedEdition) {
                limitedEditionLabel.classList.remove('hidden');
            } else {
                limitedEditionLabel.classList.add('hidden');
            }
        }

        if (!card) {
            this.updateShippingDelay(variantData);
        }

        if (!modal && !card) {
            if (this.latestPromoVariantId === matchingVariant.id) {
                this.updatePromoText(variantData);
            }
            this.updateEarlyAccessRestriction(variantData);
        }
        if (!retired && !card) {
            if (variantIdInput) {
                variantIdInput.value = matchingVariant.id;
            }
            if (quantitySelector) {
                const mainQuantity = quantitySelector.querySelector('#main-quantity');
                if (mainQuantity) {
                    mainQuantity.value = 1;
                }
            }
            
        }

        const formatLocalizedMoney = (cents) => Utility.formatLocalizedMoney(cents);

        if (!modal && !card) {
            // Notify Me / Back In Stock toggle
            const variant = variantData || matchingVariant;
            const isAvailable = Boolean(variant && variant.available === true);

            const notifyContainer = this.notifyContainer
            const notifyButton = this.notifyButton

            // keep data in sync
            if (notifyButton && variant && variant.id) {
                notifyButton.dataset.variantId = String(variant.id);
            }

            // Sync the DOM limited-edition flag so handleOutOfStock always reads the current variant's state
            if (notifyContainer && variantData) {
                notifyContainer.dataset.isLimitedEdition = variantData.limitedEdition ? 'true' : 'false';
            }

            // container visibility
            if (notifyContainer) {
                notifyContainer.style.display = isAvailable ? 'none' : 'block';
            if (isAvailable) {
                notifyContainer.setAttribute('aria-hidden', 'true');
            } else {
                notifyContainer.removeAttribute('aria-hidden');
            }
            }

            // button visibility
            if (notifyButton) {
                notifyButton.style.display = isAvailable ? 'none' : '';
            }

            if (optionNameHandle === 'shape') {
                  const shapeSwatch = document.querySelector('.swatch-btn-shape.selected');
                  if (shapeSwatch) {
                    this.selectedShape = shapeSwatch.dataset.swatchValue;
                  }

                  ProductPage.updateShapeGuide();
                  if (ogTitleWithShape) {
                    ogTitleWithShape.setAttribute('content', productData.title + ' - ' + swatchValue);
                  }
                  if (ogImage && matchingVariant.featured_image) {
                    ogImage.setAttribute('content', matchingVariant.featured_image.src);
                  }
                  if (ogImageSecureUrl && matchingVariant.featured_image) {
                    ogImageSecureUrl.setAttribute('content', matchingVariant.featured_image.src);
                  }

                  if (variantData.behindTheProduct && behindProdAcc) {
                      behindProdAcc.innerHTML = variantData.behindTheProduct;
                  }
                  if (variantData.productFeatures && featuresAcc) {
                      featuresAcc.innerHTML = variantData.productFeatures;
                  }
                  if (variantData.techSpecs && techSpecsAcc) {
                      techSpecsAcc.innerHTML = variantData.techSpecs;
                  }
                  if (variantData.detailsCare && detailsCareAcc) {
                      detailsCareAcc.innerHTML = variantData.detailsCare;
                  }
                }
                if (typeof ProductPage !== 'undefined' && typeof ProductPage.updateStatBars === 'function') {
                    ProductPage.updateStatBars(variantData);
                }
                this.updateImageGallery(modal, matchingVariant.id, productData.handle, this.modelInfoParts);
            if (optionNameHandle === 'color' || optionNameHandle === 'design') {
                const gcImage = document.querySelector('.gc-image img');
                if (gcImage) {
                    gcImage.src = matchingVariant.featured_image.src;
                }
                // START AMPED PRO AIR SPECIFIC
                if (optionNameHandle === 'color' && productData.title.includes('Pro Air')) {
                    if (announcementBar) {
                        announcementBar.style.backgroundColor = selectedBtn.dataset.bgColor;
                    }
                    if (addToCartBtn) {
                        addToCartBtn.style.backgroundColor = selectedBtn.dataset.bgColor;
                    }
                    if (fixedAddToCartBtn) {
                        fixedAddToCartBtn.style.backgroundColor = selectedBtn.dataset.bgColor;
                    }
                    const fbtProducts = document.querySelectorAll('.fbt-product-card');
                    if (fbtProducts.length) {
                        fbtProducts.forEach((product) => {
                        const swatches = product.querySelectorAll('.swatch-btn-color');
                        let swatchToSelect = null;
                        Array.from(swatches).forEach((swatch) => {
                            if (swatch.dataset.swatchValue.includes(swatchValue)) {
                                swatchToSelect = swatch;
                            } else if(swatchValue == 'Silver') {
                                if (swatch.dataset.swatchValue.includes('Black')) {
                                    swatchToSelect = swatch;
                                }
                            }
                        });
                        if (swatchToSelect) {
                            swatchToSelect.click();
                        }
                    });
                    }
                }
                // END AMPED PRO AIR SPECIFIC
                this.updateImageGallery(modal, matchingVariant.id, productData.handle, this.modelInfoParts);
            }
            // prices is a NodeList on the PDP (ProductPage.pricesMain) and a single element in the modal (parent.querySelector('.prices')).
            const updatePriceElement = (price) => {
                price.innerHTML = matchingVariant.compare_at_price
                    ? `<span class="compare-price">${formatLocalizedMoney(matchingVariant.compare_at_price)}</span><span class="price on-sale">${formatLocalizedMoney(matchingVariant.price)}</span>`
                    : `<span class="price">${formatLocalizedMoney(matchingVariant.price)}</span>`;
            };

            if (prices && prices.length) {
                prices.forEach((price) => {
                    updatePriceElement(price);
                });
            } else if (prices) {
                updatePriceElement(prices);
            }

            if (this.stickySubmitBtn && matchingVariant) {
                const stickyPriceSpan = this.stickySubmitBtn.querySelector('span');

                if (stickyPriceSpan) {
                    stickyPriceSpan.innerHTML = formatLocalizedMoney(matchingVariant.price);
                }
            }

            const isPreorder = variantData?.preorder === true;

            const setCartBtnLabel = (btn) => {
                Shared.setButtonLabel(btn, isPreorder ? themeT('product.pre_order') : themeT('product.add_to_cart'));
                btn.dataset.preorder = isPreorder;
            };
            if (addToCartBtn) {
                setCartBtnLabel(addToCartBtn);
            }
            if (fixedAddToCartBtn) {
                setCartBtnLabel(fixedAddToCartBtn);
            }



            const url = new URL(window.location.href);
            url.searchParams.set('variant', matchingVariant.id);
            window.history.pushState({ path: url.toString() }, '', url.toString());
        }
      if (!card) {
        if (this.productType == 'Apparel') {
          this.modelInfoParts = variantData.modelInfo ? variantData.modelInfo.split(' | ') : null;

          if (!this.verticalGallery && typeof ProductPage !== 'undefined' && ProductPage.modelInfo && ProductPage.modelInfo.length) {
            ProductPage.modelInfo.forEach((el) => {
              const paragraph = el.querySelector('p');
              if (!paragraph) { return; }
              if (this.modelInfoParts) {
                paragraph.textContent = `Model is ${this.modelInfoParts[0]} wearing ${this.modelInfoParts[1]}`;
                el.style.display = '';
              } else {
                el.style.display = 'none';
              }
            });
          }
        }
        if (!retired) {
          this.updateSwatchesStock(swatchValue, optionNameHandle, modal, card ? parent : false);
          this.handleOutOfStock(modal, matchingVariant.id);
        }
      }
    
      if (customizeBtn && !modal && !card) {
        if (variantData.disableCustoms) {
            customizeBtn.style.display = 'none';
            ProductPage.showCustomOptionsPDP('none');
            ProductPage.handleSaveCustomizations(false);
        } else {
            customizeBtn.style.display = "block";
        }
      }
        const gripError = parent.querySelector('.grip-error');
        if (gripError) {
            gripError.style.display = 'none';
        }
    
        if (saveBtn) {
            saveBtn.disabled = false;
        }
    
        if (card) {
            if (urls && urls.length) {
                urls.forEach((url => url.href = "/products/" + productData.handle + "?variant=" + matchingVariant.id));
            }
            if (variantIdInput) {
                variantIdInput.value = matchingVariant.id;
                // Quick Add sends this as the Shipping Delay line property (see Cart.addToCart).
                variantIdInput.dataset.shippingDelay = variantData?.shippingDelay || '';
            }

            if (prices) {
                if (!prices.closest('.promo-container')) {
                    let promoPrice = null;
                    if (addToCartBtn && addToCartBtn.dataset.promoPrice) {
                        promoPrice = addToCartBtn.dataset.promoPrice;
                    }

                    if (promoPrice) {
                        const promoPriceNumber = parseFloat(String(promoPrice).replace(/[^0-9.]/g, ''));
                        const promoPriceDisplay = Number.isFinite(promoPriceNumber)
                            ? formatLocalizedMoney(Math.round(promoPriceNumber * 100))
                            : String(promoPrice);

                        prices.innerHTML = `<span class="compare-price">${formatLocalizedMoney(matchingVariant.price)}</span><span class="price on-sale">${promoPriceDisplay}</span>`;
                    } else {
                        prices.innerHTML = matchingVariant.compare_at_price
                            ? `<span class="compare-price">${formatLocalizedMoney(matchingVariant.compare_at_price)}</span><span class="price on-sale">${formatLocalizedMoney(matchingVariant.price)}</span>`
                            : `<span class="price">${formatLocalizedMoney(matchingVariant.price)}</span>`;
                    }
                }
            }

            const image = parent.querySelector('.product-card-img');
            if (image && optionNameHandle == 'color') {
                image.src = selectedBtn.dataset.firstImg;
                image.alt = selectedBtn.dataset.imageAlt;
                image.dataset.nextImg = selectedBtn.dataset.nextImg;
                image.dataset.firstImg = selectedBtn.dataset.firstImg;
            }
            if (addToCartBtn){
                if (matchingVariant.available) {
                    if (addToCartBtn.dataset.updatePrice == 'true') {
                        // Keep a card's own label (data-label) next to the price, matching the Liquid markup
                        const price = formatLocalizedMoney(matchingVariant.price);
                        addToCartBtn.textContent = addToCartBtn.dataset.label
                            ? `${addToCartBtn.dataset.label} - ${price}`
                            : themeT('product.quick_add_price', { price });
                    } else {
                        // Cards can set their own label (data-label), e.g. "Add to Cart" on the home-ab sections
                        addToCartBtn.textContent = addToCartBtn.dataset.label || themeT('product.quick_add');
                    }
                    addToCartBtn.disabled = false;
                    addToCartBtn.classList.remove('out-of-stock');
                } else {
                    addToCartBtn.disabled = true;
                    addToCartBtn.textContent = themeT('product.out_of_stock');
                    addToCartBtn.classList.add('out-of-stock');
                }
            }

            this.updateEarlyAccessRestriction(variantData, { card: true, addToCartBtn });

            // Re-evaluate stock for other swatches in the card
            this.updateSwatchesStock(swatchValue, optionNameHandle, false, parent);

            // toggle swatch visibility
            if (optionNameHandle == 'shape') {
                const colorSwatches = parent.querySelectorAll('.swatch-btn-color');
                if (colorSwatches) {
                    const filteredVariants = productData.variants.filter(variant => variant.title.includes(swatchValue));
                    const filteredSwatches = Array.from(colorSwatches).filter(swatch => {
                        const swatchValue = swatch.dataset.swatchValue;
                        return filteredVariants.some(variant => variant.title.includes(swatchValue));
                    });
                    colorSwatches.forEach((swatch) => {
                        if (filteredSwatches.includes(swatch)) {
                            swatch.classList.remove('hide-swatch');
                        } else {
                            swatch.classList.add('hide-swatch');
                        }
                    });
                }
            }
        }
    },

    updateSelectedSwatches: function (parent, optionNameHandle, selectedBtn, card, modal) {
        if (!parent || !selectedBtn) {
            return [];
        }
        // Use data-option-name selector instead of class-based selector for reliability
        const allOptionSwatches = parent.querySelectorAll(`[data-option-name="${selectedBtn.dataset.optionName}"]`);

        // Update selected swatch to 'selected' class styling
        allOptionSwatches.forEach((swatch) => {
            swatch.classList.remove('selected');
        });
        selectedBtn.classList.add('selected');

        // Loop through all swatches to find the ones currently selected
        let allSwatches = Array.from(parent.querySelectorAll('.swatch-btn'));

        let selectedOptions = [];
        allSwatches.forEach((swatch) => {
            // Look for the '.selected' CSS class OR the native HTML <option> selected property
            if (swatch.classList.contains('selected') || (swatch.tagName === 'OPTION' && swatch.selected)) {
                // Ensure we don't push duplicates
                if (!selectedOptions.includes(swatch.dataset.swatchValue)) {
                    selectedOptions.push(swatch.dataset.swatchValue);
                }
            }
        });
        return selectedOptions;
    },

    handleQuantityChange: function (btn, operation, modal = false, context = null) {
        let input;
        let root;

        if (context) {
            const baseParent = context.parent;
            // subtotal is outside .popup-chat-customizer__content,
            // so query from the panel/root that contains both sections.
            root = baseParent.closest('#popup-chat-customizer') || baseParent.closest('[data-product-customizer-panel]') || baseParent.parentElement || baseParent;
            input = root.querySelector('[data-customizer-qty-input]');
        } else {
            const container = btn.closest('.quantity');
            input = container ? container.querySelector('.number-input') : null;
        }

        if (!input) {
            return;
        }

        let currentValue = parseInt(input.value, 10) || 1;
        let newValue = currentValue;

        if (operation === 'increase') {
            newValue = currentValue + 1;
        } else if (operation === 'decrease') {
            if (currentValue > 1) {
                newValue = currentValue - 1;
            }
        }
        input.value = newValue;

        if (context) {
            const variantIdInput = root.querySelector('[data-customizer-variant-input]');
            const subtotalElement = root.querySelector('[data-customizer-subtotal]');

            // Price, prefer variant id in hidden input, fallback to selected variant from context if available
            const activeVariantId = variantIdInput ? String(variantIdInput.value) : '';
            const numericVariantId = activeVariantId.replace('gid://shopify/ProductVariant/', '');

            const matchingVariant = numericVariantId
                ? context.productData.variants.find((variant) => String(variant.id) === String(numericVariantId))
                : null;

            const priceCents = matchingVariant ? Number(matchingVariant.price) : 0;
            const subtotalCents = priceCents * newValue;

            if (subtotalElement) {
                subtotalElement.textContent = `$${(subtotalCents / 100).toFixed(2)}`;
            }
        } else {
            let addToCartBtn;
            let variantData;
            if (modal) {
                addToCartBtn = Modal.addToCartBtn;
                variantData = Modal.productDetails;
            } else {
                addToCartBtn = ProductPage.addToCartBtn;
                variantData = ProductPage.productDetails;
            }
            const inventory = variantData.inventory;
            const price = (variantData.price * newValue / 100).toFixed(2).replace(/\.00$/, '')

            if ((inventory < 1 && variantData.available) || input.value <= inventory) {
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    Shared.setButtonLabel(addToCartBtn, modal ? themeT('product.quick_add_price', { price: price }) : themeT('product.add_to_cart'));
                }
                input.classList.remove('invalid-quantity');
            } else {
                if (addToCartBtn) {
                    addToCartBtn.disabled = true;
                    Shared.setButtonLabel(addToCartBtn, themeT('product.quantity_unavailable'));
                }
                input.classList.add('invalid-quantity');
            }
        }
    },

    checkLoopExclusions: function (variantId, modal = false, available = true) {
        const { loopErrorText } = this;
        let addToCartBtn, fixedAddToCartBtn;

        if (modal) {
            addToCartBtn = Modal.addToCartBtn;
        } else {
            addToCartBtn = ProductPage.addToCartBtn;
            if (ProductPage.fixedAddToCartBtn) {
                fixedAddToCartBtn = ProductPage.fixedAddToCartBtn.querySelector('.fixed-add-to-cart-btn');
            }
        }

        if (!document.body.classList.contains('loop-returns-activated')) {
            if (addToCartBtn) addToCartBtn.classList.remove('loop-excluded');
            if (fixedAddToCartBtn) fixedAddToCartBtn.classList.remove('loop-excluded');
            if (loopErrorText) loopErrorText.classList.remove('loop-excluded');
            return;
        }

        const excludedIds = window.loopExcludedVariants || [];
        const isExcluded = excludedIds.includes(Number(variantId));

        if (isExcluded) {
            // Always hide the ATC buttons if excluded
            if (addToCartBtn) addToCartBtn.classList.add('loop-excluded');
            if (fixedAddToCartBtn) fixedAddToCartBtn.classList.add('loop-excluded');

            // Only show the error text if the item is actually AVAILABLE (in stock)
            // If it's OOS, we want the standard OOS button to show without this error text.
            if (available) {
                if (loopErrorText) loopErrorText.classList.add('loop-excluded');
            } else {
                if (loopErrorText) loopErrorText.classList.remove('loop-excluded');
            }
        } else {
            if (addToCartBtn) addToCartBtn.classList.remove('loop-excluded');
            if (fixedAddToCartBtn) fixedAddToCartBtn.classList.remove('loop-excluded');
            if (loopErrorText) loopErrorText.classList.remove('loop-excluded');
        }
    },

    initMaestraEventListeners: function () {
        // Listen for the custom event dispatched by maestra.js after DOM injection.
        document.addEventListener('maestra:fbt:loaded', (event) => {
            const container = event.detail.container;

            if (!container) {
                return;
            }

            this.bindFbtCards(container);
        });
    },

    bindFbtCards: function (container) {
        const newSwatches = container.querySelectorAll('.swatch-btn');
        if (newSwatches.length) {
            // Attach click handlers to newly injected swatches.
            newSwatches.forEach((swatch) => {
                swatch.addEventListener('click', () => {
                    this.handleSwatchChange(swatch, false, true);
                });
            });
        }

        const selectSwatches = container.querySelectorAll('select');

        if (selectSwatches.length) {
            selectSwatches.forEach((select) => {
                select.addEventListener('change', () => {
                    this.handleSwatchChange(select, false, true);
                });
            });
        }

        const newCards = container.querySelectorAll('.fbt-product-card');

        if (!newCards.length) {
            return;
        }

        // Trigger initial state evaluation for the newly rendered cards.
        newCards.forEach((card) => {
            // Ensure it triggers on load even if the card only has dropdowns
            const firstSwatch = card.querySelector('.selected') || card.querySelector('option[selected]') || card.querySelector('option');

            if (firstSwatch) {
                this.handleSwatchChange(firstSwatch, false, true);
            }

            const quickAddBtn = card.querySelector('.quick-add, .quick-add-to-cart');

            if (quickAddBtn && typeof Cart !== 'undefined') {
                quickAddBtn.addEventListener('click', (event) => {
                    Cart.addToCart(event);
                });
            }
        });
    },

    /**
     * Updates the CSS background of elements based on the selected variant.
     * Requires the 'data-dynamic-bg-target' attribute on target HTML elements.
     * Depends on the 'dynamicVariantBackgrounds' window object generated by Liquid.
     *
     * @param {string|number} variantId - The currently selected variant ID.
     */
    updateDynamicBackground: function (variantId) {
        const targets = document.querySelectorAll('[data-dynamic-bg-target]');
        const backgroundMap = window.dynamicVariantBackgrounds;

        // Parse raw variant backgrounds
        let rawBackgroundMap = null;
        const rawDataEl = document.getElementById('raw-variant-backgrounds');
        if (rawDataEl) {
            try {
                rawBackgroundMap = JSON.parse(rawDataEl.textContent);
            } catch (e) {
                // Silently fail if JSON is invalid
            }
        }

        if (targets.length > 0 && backgroundMap !== undefined) {
            targets.forEach((target) => {
                let newBackground = backgroundMap[variantId];

                if (target.hasAttribute('data-default-bg') && rawBackgroundMap) {
                    const rawBg = rawBackgroundMap[variantId];
                    if (rawBg && rawBg.trim() !== '') {
                        newBackground = rawBg;
                    } else {
                        newBackground = target.getAttribute('data-default-bg');
                    }
                }

                // Apply the new background, fallback to data-default-bg, or clear it completely
                if (newBackground && newBackground.trim() !== '') {
                    target.style.background = newBackground;
                } else if (target.hasAttribute('data-default-bg')) {
                    target.style.background = target.getAttribute('data-default-bg');
                } else {
                    target.style.background = '';
                }
            });
        }
    },

    initStickyBar: function () {
        const { stickyBar, stickyShapeBtns, stickyColorBtns, stickySubmitBtn, stickyCloseBtn, stickyFab } = this;

        if (!stickyBar) {
            return;
        }

        const targetSelector = stickyBar.getAttribute('data-target-selector');
        
        if (!targetSelector) {
            return;
        }

        const targetElement = document.querySelector(targetSelector);
        let isUserClosed = false;

        if (targetElement) {
            // Observer to toggle Sticky Bar and FAB visibility when scrolling past the main ATC section
            const handleIntersect = (entries) => {
                const entry = entries[0];
                const targetRect = entry.boundingClientRect;

                if (targetRect.bottom < 0) {
                    if (!isUserClosed) {
                        stickyBar.classList.add('is-visible');
                        stickyBar.setAttribute('aria-hidden', 'false');

                        if (stickyFab) {
                            stickyFab.classList.remove('is-visible');
                            stickyFab.setAttribute('aria-hidden', 'true');
                            stickyFab.setAttribute('aria-expanded', 'true');
                        }
                    } else if (stickyFab) {
                        stickyFab.classList.add('is-visible');
                        stickyFab.setAttribute('aria-hidden', 'false');
                        stickyFab.setAttribute('aria-expanded', 'false');
                    }
                } else {
                    stickyBar.classList.remove('is-visible');
                    stickyBar.setAttribute('aria-hidden', 'true');

                    if (stickyFab) {
                        stickyFab.classList.remove('is-visible');
                        stickyFab.setAttribute('aria-hidden', 'true');
                    }
                }
            };

            const observer = new IntersectionObserver(handleIntersect, {
                root: null,
                threshold: 0
            });

            observer.observe(targetElement);

            // Handle manual user dismiss/open events (Close Button & FAB)
            if (stickyCloseBtn && stickyFab) {
                stickyCloseBtn.addEventListener('click', () => {
                    isUserClosed = true;
                    stickyBar.classList.remove('is-visible');
                    stickyBar.setAttribute('aria-hidden', 'true');
                    stickyCloseBtn.setAttribute('aria-expanded', 'false');

                    stickyFab.classList.add('is-visible');
                    stickyFab.setAttribute('aria-hidden', 'false');
                    stickyFab.setAttribute('aria-expanded', 'false');
                    stickyFab.focus();
                });

                stickyFab.addEventListener('click', () => {
                    isUserClosed = false;
                    stickyFab.classList.remove('is-visible');
                    stickyFab.setAttribute('aria-hidden', 'true');
                    stickyFab.setAttribute('aria-expanded', 'true');

                    stickyBar.classList.add('is-visible');
                    stickyBar.setAttribute('aria-hidden', 'false');
                    stickyCloseBtn.setAttribute('aria-expanded', 'true');
                    stickyCloseBtn.focus();
                });

                // Allow users to close the sticky bar via the Escape key
                document.addEventListener('keydown', (event) => {
                    if (event.key === 'Escape' || event.key === 'Esc') {
                        const isBarVisible = stickyBar.classList.contains('is-visible');

                        if (isBarVisible) {
                            isUserClosed = true;
                            stickyBar.classList.remove('is-visible');
                            stickyBar.setAttribute('aria-hidden', 'true');
                            stickyCloseBtn.setAttribute('aria-expanded', 'false');

                            stickyFab.classList.add('is-visible');
                            stickyFab.setAttribute('aria-hidden', 'false');
                            stickyFab.setAttribute('aria-expanded', 'false');

                            stickyFab.focus();
                        }
                    }
                });
            }
        }

        // Proxy sticky bar swatch clicks to the main product form via handleSwatchChange
        // (direct call — more reliable than synthetic .click() for early access overlay, etc.)
        const findMainFormSwatch = (optionClass, value) => {
            if (!value) return null;
            const form = document.querySelector('#product-swatches');
            if (!form) return null;
            return form.querySelector(`.${optionClass}[data-swatch-value="${CSS.escape(value)}"]`);
        };

        const triggerMainSwatchChange = async (optionClass, value) => {
            const mainSwatch = findMainFormSwatch(optionClass, value);
            if (mainSwatch) {
                await this.handleSwatchChange(mainSwatch);
            }
        };

        const triggerMainFormClick = (selector) => {
            const form = document.querySelector('#product-swatches');
            const mainBtn = form ? form.querySelector(selector) : document.querySelector(selector);

            if (mainBtn) {
                mainBtn.click();
            }
        };

        if (stickyShapeBtns && stickyShapeBtns.length > 0) {
            stickyShapeBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    const value = event.currentTarget.getAttribute('data-swatch-value');
                    triggerMainSwatchChange('swatch-btn-shape', value);
                });
            });
        }

        if (stickyColorBtns && stickyColorBtns.length > 0) {
            stickyColorBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    const value = event.currentTarget.getAttribute('data-swatch-value');
                    triggerMainSwatchChange('swatch-btn-color', value);
                });
            });
        }

        // Handle Sticky ATC submit and simulate loading state
        if (stickySubmitBtn) {
            stickySubmitBtn.addEventListener('click', () => {
                const originalHTML = stickySubmitBtn.innerHTML;
                stickySubmitBtn.innerHTML = themeT('product.adding_to_cart');

                triggerMainFormClick('.add-to-cart-main');

                setTimeout(() => {
                    stickySubmitBtn.innerHTML = originalHTML;
                }, 2000);
            });
        }
    },
};